<template>
  <header class="header">
    <div class="w-header h-100 d-flex justify-content-between align-items-center">
      <div class="nav-left d-flex align-items-center">
        <div class="logo cursor-pointer">
          <img src="@/assets/images/header/tbl-logo.svg" alt="" @click="goHome" />
        </div>
        <div class="nav-list d-flex align-items-center" v-if="$store.state.screenWidth > 768">
          <div
            :class="['nav-item drop_toggle', firstNavIndex == index ? 'active' : '', selectMenu == item.name ? 'menu_arrow' : '']"
            v-for="(item, index) in navList"
            @mouseover="menuHover(item)"
            @mouseleave="menuLeave"
            :key="index"
          >
            <div class="cursor-pointer item-name" :class="[item.children && item.children.length > 0 ? 'with-children' : '']" @click="changeNav(item, index)">
              {{ item.name }}
              <i class="el-icon-arrow-down" v-show="item.children && item.children.length > 0"></i>
            </div>
            <!-- 产品二级菜单 -->
            <div
              class="nav-second"
              v-if="item.children && item.children.length > 0"
              :class="[item.id, item.children && item.children.length > 0 ? 'with-children' : '']"
            >
              <div class="hidden-block"></div>
              <div class="nav-second-list">
                <template v-if="item.id == 'about'">
                  <div class="contact" v-for="contactItem in item.children" :key="contactItem.name" @click="jumpRoute(contactItem.routerPath)">
                    {{ contactItem.name }}
                  </div>
                </template>
                <div class="nav-second-content" :class="item.id">
                  <div class="d-flex">
                    <div class="nav-second-wrap" v-for="(secondItem, secondIndex) in item.children" :key="secondIndex">
                      <!-- 产品三级菜单 -->
                      <template v-if="secondItem.children && item.id == 'products'">
                        <div class="nav-second-item w-100">
                          <div>
                            <div class="item-name">
                              <span>{{ secondItem.name }}</span>
                            </div>
                          </div>
                          <i class="el-icon-arrow-right nav-second-item-arrow" v-if="secondItem.children"></i>
                        </div>
                        <div class="nav-third" v-if="secondItem.id != 'iot'">
                          <div
                            v-for="(thirdItem, thirdIndex) in secondItem.children"
                            :key="thirdIndex"
                            class="nav-third-item d-flex align-items-center justify-content-between cursor-pointer"
                            :class="[thirdItem.class]"
                            @click="handleThirdClick(secondItem, thirdIndex)"
                            @mouseover="handleProductHover(thirdItem)"
                            @mouseleave="handleProductLeave"
                          >
                            <div class="w-100 item-name d-flex align-items-center justify-content-between">
                              <div class="d-flex">
                                <div class="img-box">
                                  <img
                                    :src="selectProductInfo.label == thirdItem.name ? thirdItem.activeIcon : thirdItem.icon"
                                    :class="thirdItem.iconClass"
                                    alt=""
                                  />
                                </div>
                                <div class="text-wrap">
                                  <div class="label" style="width: 110%;">
                                    {{ thirdItem.name }}
                                  </div>
                                  <div class="desc">
                                    {{ thirdItem.desc }}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="nav-third" v-else>
                          <div class="nav-product-col">
                            <div
                              v-for="(thirdItem, thirdIndex) in secondItem.children.slice(0, 4)"
                              :key="thirdIndex"
                              class="nav-third-item d-flex align-items-center justify-content-between cursor-pointer"
                              :class="[thirdItem.class]"
                              @click="handleThirdClickNew(thirdItem)"
                              @mouseover="handleProductHover(thirdItem)"
                              @mouseleave="handleProductLeave"
                            >
                              <div class="w-100 item-name d-flex align-items-center justify-content-between">
                                <div class="d-flex">
                                  <div class="img-box">
                                    <img
                                      :src="selectProductInfo.label == thirdItem.name ? thirdItem.activeIcon : thirdItem.icon"
                                      :class="thirdItem.iconClass"
                                      alt=""
                                    />
                                  </div>
                                  <div class="text-wrap">
                                    <div class="label">
                                      {{ thirdItem.name }}
                                    </div>
                                    <div class="desc">
                                      {{ thirdItem.desc }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="nav-product-col">
                            <div
                              v-for="(thirdItem, thirdIndex) in secondItem.children.slice(4, 8)"
                              :key="thirdIndex"
                              class="nav-third-item d-flex align-items-center justify-content-between cursor-pointer"
                              :class="[thirdItem.class]"
                              @click="handleThirdClickNew(thirdItem)"
                              @mouseover="handleProductHover(thirdItem)"
                              @mouseleave="handleProductLeave"
                            >
                              <div class="w-100 item-name d-flex align-items-center justify-content-between">
                                <div class="d-flex">
                                  <div class="img-box">
                                    <img
                                      :src="selectProductInfo.label == thirdItem.name ? thirdItem.activeIcon : thirdItem.icon"
                                      :class="thirdItem.iconClass"
                                      alt=""
                                    />
                                  </div>
                                  <div class="text-wrap">
                                    <div class="label">
                                      {{ thirdItem.name }}
                                    </div>
                                    <div class="desc">
                                      {{ thirdItem.desc }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="nav-product-col">
                            <div
                              v-for="(thirdItem, thirdIndex) in secondItem.children.slice(8, 12)"
                              :key="thirdIndex"
                              class="nav-third-item d-flex align-items-center justify-content-between cursor-pointer"
                              :class="[thirdItem.class]"
                              @click="handleThirdClickNew(thirdItem)"
                              @mouseover="handleProductHover(thirdItem)"
                              @mouseleave="handleProductLeave"
                            >
                              <div class="w-100 item-name d-flex align-items-center justify-content-between">
                                <div class="d-flex">
                                  <div class="img-box">
                                    <img
                                      :src="selectProductInfo.label == thirdItem.name ? thirdItem.activeIcon : thirdItem.icon"
                                      :class="thirdItem.iconClass"
                                      alt=""
                                    />
                                  </div>
                                  <div class="text-wrap">
                                    <div class="label">
                                      {{ thirdItem.name }}
                                    </div>
                                    <div class="desc">
                                      {{ thirdItem.desc }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>

                      <!-- 场景三级菜单 -->
                      <template v-if="secondItem.children && item.id == 'scenes'">
                        <div class="nav-third">
                          <div class="nav-third-col">
                            <div
                              v-for="(thirdItem, thirdIndex) in secondItem.children.slice(0, 5)"
                              :key="thirdIndex"
                              class="nav-third-item d-flex align-items-center justify-content-between cursor-pointer"
                              :class="[
                                thirdItem.class,
                                selectSceneInfo.label == thirdItem.name ? 'selected' : '',
                                thirdItem.withBottomArrow ? 'withBottomArrow' : 'withRightArrow',
                              ]"
                              @click="handleThirdClickNew(thirdItem)"
                              @mouseover="handleSceneHover(thirdItem)"
                            >
                              <div class="w-100 item-name d-flex align-items-center justify-content-between">
                                <div class="d-flex">
                                  <div class="img-box">
                                    <img
                                      :src="selectSceneInfo.label == thirdItem.name ? thirdItem.activeIcon : thirdItem.icon"
                                      :class="thirdItem.iconClass"
                                      alt=""
                                    />
                                  </div>
                                  <div class="text-wrap">
                                    <div class="label">
                                      {{ thirdItem.name }}
                                    </div>
                                    <div class="desc">
                                      {{ thirdItem.desc }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="nav-third-col">
                            <div
                              v-for="(thirdItem, thirdIndex) in secondItem.children.slice(5, 10)"
                              :key="thirdIndex"
                              class="nav-third-item d-flex align-items-center justify-content-between cursor-pointer"
                              :class="[
                                thirdItem.class,
                                selectSceneInfo.label == thirdItem.name ? 'selected' : '',
                                thirdItem.withTopArrow ? 'withTopArrow' : '',
                              ]"
                              @click="handleThirdClickNew(thirdItem)"
                              @mouseover="handleSceneHover(thirdItem)"
                            >
                              <div class="w-100 item-name d-flex align-items-center justify-content-between">
                                <div class="d-flex">
                                  <div class="img-box">
                                    <img
                                      :src="selectSceneInfo.label == thirdItem.name ? thirdItem.activeIcon : thirdItem.icon"
                                      :class="thirdItem.iconClass"
                                      alt=""
                                    />
                                  </div>
                                  <div class="text-wrap">
                                    <div class="label">
                                      {{ thirdItem.name }}
                                    </div>
                                    <div class="desc">
                                      {{ thirdItem.desc }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="nav-third-col">
                            <div
                              v-for="(thirdItem, thirdIndex) in secondItem.children.slice(10, 15)"
                              :key="thirdIndex"
                              class="nav-third-item d-flex align-items-center justify-content-between cursor-pointer"
                              :class="[thirdItem.class, selectSceneInfo.label == thirdItem.name ? 'selected' : '']"
                              @click="handleThirdClickNew(thirdItem)"
                              @mouseover="handleSceneHover(thirdItem)"
                            >
                              <div class="w-100 item-name d-flex align-items-center justify-content-between">
                                <div class="d-flex">
                                  <div class="img-box">
                                    <img
                                      :src="selectSceneInfo.label == thirdItem.name ? thirdItem.activeIcon : thirdItem.icon"
                                      :class="thirdItem.iconClass"
                                      alt=""
                                    />
                                  </div>
                                  <div class="text-wrap">
                                    <div class="label">
                                      {{ thirdItem.name }}
                                    </div>
                                    <div class="desc">
                                      {{ thirdItem.desc }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="scene-detail">
                            <div class="image-box">
                              <img :src="selectSceneInfo.detailUrl" alt="" />
                            </div>
                            <h3>
                              {{ selectSceneInfo.label }}
                            </h3>
                            <p>
                              {{ selectSceneInfo.desc }}
                            </p>
                            <el-button type="text" @click="handleContact">
                              {{ $t('message.wisdomAi.banner.btnText') }}
                              <i class="el-icon-right"></i>
                            </el-button>
                          </div>
                        </div>
                      </template>

                      <!-- 行业三级菜单 -->
                      <template v-if="secondItem.children && item.id == 'industrys'">
                        <div class="nav-second-item w-100">
                          <div>
                            <div class="item-name">
                              <span>{{ secondItem.name }}</span>
                            </div>
                          </div>
                          <i class="el-icon-arrow-right nav-second-item-arrow" v-if="secondItem.children"></i>
                        </div>
                        <div class="nav-third">
                          <div class="nav-third-outer" v-for="(thirdItem, thirdIndex) in secondItem.children" :key="thirdIndex">
                            <div class="nav-third-item cursor-pointer" :class="[thirdItem.class]" @click="handleThirdClick(secondItem, thirdIndex)">
                              <div class="w-100 item-name d-flex justify-content-between">
                                <div class="d-flex align-items-center justify-content-center">
                                  <div class="img-box" v-html="thirdItem.icon"></div>
                                  <div class="text-wrap">
                                    <div class="label">
                                      {{ thirdItem.name }}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="nav-list-mobile" v-if="$store.state.screenWidth < 768">
        <div class="lang mr-5">
          <div class="lang-item" @click="changeLanguageMobile('en')" :class="[currentLang == 'en' ? 'active' : '']">
            EN
          </div>
          <span class="mx-3">/</span>
          <div class="lang-item" @click="changeLanguageMobile('cn')" :class="[currentLang == 'cn' ? 'active' : '']">
            CN
          </div>
        </div>
        <div class="icon-wrap">
          <img v-if="mobileMenuShow == false" @click="toggleMobileMenu" src="@/assets/images/header/open.svg" class="menu" alt="" />
          <img v-if="mobileMenuShow == true" @click="toggleMobileMenu" src="@/assets/images/header/close.svg" class="menu-off" alt="" />
        </div>
      </div>
      <div class="nav-right d-flex align-items-center" v-if="$store.state.screenWidth > 768">
        <div class="phone">
          <img src="@/assets/images/header/phone.svg" alt="" />
          +86 400-0667-887
        </div>
        <img src="@/assets/images/header/earth.svg" class="earth" alt="">
        <!-- 中英文切换 -->
        <el-dropdown v-if="langDisplay">
          <span class="loginBtn cursor-pointer ml-3">
            {{ currentLangLabel }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(lang, index) in langList" :key="index">
              <div @click="changeLanguage(lang)" class="cursor-pointer" :class="lang.code == currentLang ? 'active' : ''">
                {{ lang.label }}
              </div>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <div class="mobile-menu" v-if="mobileMenuShow">
        <div :class="['nav-item', firstNavIndex == index ? 'active' : '']" v-for="(item, index) in navListMobile" :key="index">
          <div
            class="cursor-pointer item-name d-flex align-items-center justify-content-between drop_toggle"
            :class="[selectFirstMobileMenu == item.name ? 'menu_arrow' : '']"
            @click="changeFirstMobile(item, index)"
          >
            <div>
              {{ item.name }}
            </div>
            <i class="el-icon-arrow-down nav-second-item-arrow" v-if="item.children"></i>
          </div>
          <el-collapse-transition>
            <!-- 二级菜单 -->
            <div v-if="item.children && selectFirstMobileMenu == item.name" class="nav-second">
              <div class="nav-second-list">
                <div v-for="(secondItem, secondIndex) in item.children" :key="secondIndex">
                  <div
                    class="nav-second-item cursor-pointer d-flex align-items-center justify-content-between drop_toggle"
                    :class="[secondNavIndex == secondIndex ? 'active' : '', selectMobileMenu == secondItem.name ? 'menu_arrow' : '']"
                    @click="changeSecondMobile(secondItem, index, secondIndex)"
                    v-if="item.id != 'scenes'"
                  >
                    <div class="d-flex align-items-center">
                      <div class="item-name">
                        {{ secondItem.name }}
                      </div>
                    </div>
                    <i class="el-icon-arrow-down nav-second-item-arrow" v-if="secondItem.children || secondItem.children1"></i>
                  </div>

                  <!-- 三级菜单 -->
                  <div class="nav-third" v-if="secondItem.children && item.id == 'scenes'">
                    <div v-for="(thirdItem, thirdIndex) in secondItem.children" :key="thirdIndex" class="nav-third-item">
                      <div class="item-name" @click="handleThirdClick(secondItem, thirdIndex)">
                        {{ thirdItem.name }}
                      </div>
                    </div>
                  </div>
                  <el-collapse-transition>
                    <!-- 三级菜单 -->
                    <div class="nav-third" v-if="secondItem.children && selectMobileMenu == secondItem.name">
                      <div v-for="(thirdItem, thirdIndex) in secondItem.children" :key="thirdIndex" class="nav-third-item">
                        <div class="item-name" @click="handleThirdClick(secondItem, thirdIndex)">
                          {{ thirdItem.name }}
                        </div>
                      </div>
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
            </div>
          </el-collapse-transition>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeaderComponent',
  props: ['currentLang'],
  inject: ['changeAppLanguage'],
  data() {
    return {
      langDisplay: globalUrl.VUE_LANG_DISPLAY,
      selectSceneInfo: {
        label: this.$t('message.header.sceneLabel1'),
        desc: this.$t('message.header.sceneDesc1'),
        detailUrl: require('@/assets/images/header/detail1.png'),
      },
      selectProductInfo: {
        label: '',
        desc: '',
      },
      selectPlatform: [],
      hoverPlatform: '',
      firstNavIndex: -1, // 当前选中的导航索引
      navList: [
        {
          id: 'products',
          name: this.$t('message.header.firstNav1'), // 产品
          routerPath: '',
          children: [
            {
              id: 'software',
              name: this.$t('message.header.secondProductNav1'),
              routerPath: '',
              pid: 'second-software',
              children: [
                {
                  name: this.$t('message.header.productLabel1'),
                  icon: require('@/assets/images/header/scene-icon1.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon1-active.svg'),
                  iconClass: 'w22',
                  desc: this.$t('message.header.productDesc1'),
                  routerPath: '/Wisdom_AI_Applications',
                },
                {
                  name: this.$t('message.header.productLabel2'),
                  icon: require('@/assets/images/header/product-icon2.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active2.svg'),
                  iconClass: 'w18',
                  desc: this.$t('message.header.productDesc2'),
                  routerPath: '/Wisdom_BI_Analysis',
                },
                {
                  name: this.$t('message.header.productLabel3'),
                  icon: require('@/assets/images/header/product-icon3.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active3.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc3'),
                  routerPath: '/Business_Manage_System',
                },
                {
                  name: this.$t('message.header.productLabel4'),
                  icon: require('@/assets/images/header/product-icon1.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active1.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc4'),
                  routerPath: '/Intelligent_Device_Management_Platform',
                },
              ],
            },
            {
              id: 'hardware',
              name: this.$t('message.header.secondProductNav2'),
              routerPath: '',
              pid: 'second-hardware',
              children: [
                {
                  name: this.$t('message.header.productLabel5'),
                  icon: require('@/assets/images/header/product-icon5.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active5.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc5'),
                  routerPath: '/Automation',
                },
                {
                  name: this.$t('message.header.productLabel6'),
                  icon: require('@/assets/images/header/product-icon6.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active6.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc6'),
                  routerPath: '/AI_Robot',
                },
                {
                  name: this.$t('message.header.productLabel18'),
                  icon: require('@/assets/images/header/product-icon18.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active18.svg'),
                  iconClass: 'w20',
                  desc: this.$t('message.header.productDesc18'),
                  routerPath: '/Follow_Robot',
                },
              ],
            },
            {
              id: 'iot',
              name: this.$t('message.header.secondProductNav3'),
              routerPath: '',
              pid: 'second-iot',
              children: [
                {
                  name: this.$t('message.header.productLabel7'),
                  icon: require('@/assets/images/header/product-icon7.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active7.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc7'),
                  routerPath: '/Wearable_Devices',
                },
                {
                  name: this.$t('message.header.productLabel8'),
                  icon: require('@/assets/images/header/product-icon8.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active8.svg'),
                  iconClass: 'w21',
                  desc: this.$t('message.header.productDesc8'),
                  routerPath: '/Self_Collect_Devices',
                },
                {
                  name: this.$t('message.header.productLabel9'),
                  icon: require('@/assets/images/header/product-icon9.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active9.svg'),
                  iconClass: 'w18',
                  desc: this.$t('message.header.productDesc9'),
                  routerPath: '/High_Precision_Positioning_Devices',
                },
                {
                  name: this.$t('message.header.productLabel10'),
                  icon: require('@/assets/images/header/product-icon10.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active10.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc10'),
                  routerPath: '/Display_Updated_Devices',
                },

                {
                  name: this.$t('message.header.productLabel11'),
                  icon: require('@/assets/images/header/product-icon11.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active11.svg'),
                  iconClass: 'w22',
                  desc: this.$t('message.header.productDesc11'),
                  routerPath: '/Quick_Inventory_Scanning_Devices',
                },
                {
                  name: this.$t('message.header.productLabel17'),
                  icon: require('@/assets/images/header/product-icon12.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active12.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc17'),
                  routerPath: '/Error_Proofing_Prompt_Devices',
                },
                // {
                //   name: this.$t('message.header.productLabel12'),
                //   icon: require('@/assets/images/header/product-icon12.svg'),
                //   activeIcon: require('@/assets/images/header/product-icon-active12.svg'),
                //   iconClass: 'w19',
                //   desc: this.$t('message.header.productDesc12'),
                //   routerPath: '/Lighting_Guidance_Devices',
                // },
                {
                  name: this.$t('message.header.productLabel13'),
                  icon: require('@/assets/images/header/product-icon13.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active13.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc13'),
                  routerPath: '/Unattended_Devices',
                },
                {
                  name: this.$t('message.header.productLabel14'),
                  icon: require('@/assets/images/header/product-icon14.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active14.svg'),
                  iconClass: 'w20',
                  desc: this.$t('message.header.productDesc14'),
                  routerPath: '/Tool_Circulation_Track_Devices',
                },

                {
                  name: this.$t('message.header.productLabel15'),
                  icon: require('@/assets/images/header/product-icon15.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active15.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc15'),
                  routerPath: '/Quick_Call_Devices',
                },
                {
                  name: this.$t('message.header.productLabel16'),
                  icon: require('@/assets/images/header/product-icon16.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active16.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc16'),
                  routerPath: '/Information_Perception_Devices',
                },
                {
                  name: this.$t('message.header.productLabel19'),
                  icon: require('@/assets/images/header/product-icon19.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active19.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc19'),
                  routerPath: '/Safety_Protection_Devices',
                },
                {
                  name: this.$t('message.header.productLabel20'),
                  icon: require('@/assets/images/header/product-icon20.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active20.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc20'),
                  routerPath: '/Baggage_Identification_Devices',
                },
              ],
            },
          ],
        },
        {
          id: 'scenes',
          name: this.$t('message.header.firstNav2'), // 场景
          routerPath: '',
          children: [
            {
              id: 'second-scenes',
              routerPath: '',
              pid: 'second-scenes',
              children: [
                {
                  name: this.$t('message.header.sceneLabel1'),
                  icon: require('@/assets/images/header/scene-icon1.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon1-active.svg'),
                  iconClass: 'w22',
                  desc: this.$t('message.header.sceneDesc1'),
                  routerPath: '/Supply_Chain_Manage',
                  withBottomArrow: true,
                  detailUrl: require('@/assets/images/header/detail1.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel2'),
                  icon: require('@/assets/images/header/scene-icon2.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon2-active.svg'),
                  iconClass: 'w21',
                  desc: this.$t('message.header.sceneDesc2'),
                  routerPath: '/Material_External_Warehouse_Manage',
                  withBottomArrow: true,
                  detailUrl: require('@/assets/images/header/detail2.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel3'),
                  icon: require('@/assets/images/header/scene-icon3.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon3-active.svg'),
                  iconClass: 'w18',
                  desc: this.$t('message.header.sceneDesc3'),
                  routerPath: '/Park_Manage',
                  withBottomArrow: true,
                  detailUrl: require('@/assets/images/header/detail3.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel4'),
                  icon: require('@/assets/images/header/scene-icon4.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon4-active.svg'),
                  iconClass: 'w20',
                  desc: this.$t('message.header.sceneDesc4'),
                  routerPath: '/Platform_Manage',
                  withBottomArrow: true,
                  detailUrl: require('@/assets/images/header/detail4.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel5'),
                  icon: require('@/assets/images/header/scene-icon5.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon5-active.svg'),
                  iconClass: 'w15',
                  desc: this.$t('message.header.sceneDesc5'),
                  routerPath: '/Loading_and_Unloading_Vehicle_Storage',
                  withBottomArrow: false,
                  detailUrl: require('@/assets/images/header/detail5.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel6'),
                  icon: require('@/assets/images/header/scene-icon6.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon6-active.svg'),
                  iconClass: 'w16',
                  desc: this.$t('message.header.sceneDesc6'),
                  routerPath: '/Delivery_Transport',
                  detailUrl: require('@/assets/images/header/detail6.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel7'),
                  icon: require('@/assets/images/header/scene-icon7.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon7-active.svg'),
                  iconClass: 'w20',
                  desc: this.$t('message.header.sceneDesc7'),
                  routerPath: '/Finished_Product_External_Warehouse_Manage',
                  detailUrl: require('@/assets/images/header/detail7.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel8'),
                  icon: require('@/assets/images/header/scene-icon8.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon8-active.svg'),
                  iconClass: 'w18',
                  desc: this.$t('message.header.sceneDesc8'),
                  routerPath: '/Production_Process_Data_Manage',
                  withTopArrow: true,
                  detailUrl: require('@/assets/images/header/detail8.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel9'),
                  icon: require('@/assets/images/header/scene-icon9.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon9-active.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.sceneDesc9'),
                  routerPath: '/Order_Picking',
                  withTopArrow: true,
                  detailUrl: require('@/assets/images/header/detail9.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel10'),
                  icon: require('@/assets/images/header/scene-icon10.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon10-active.svg'),
                  iconClass: 'w18',
                  desc: this.$t('message.header.sceneDesc10'),
                  routerPath: '/Finished_Product_Storage_and_Tallying',
                  withTopArrow: true,
                  detailUrl: require('@/assets/images/header/detail10.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel11'),
                  icon: require('@/assets/images/header/scene-icon11.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon11-active.svg'),
                  iconClass: 'w18',
                  desc: this.$t('message.header.sceneDesc11'),
                  routerPath: '/Operational_Standard_Manage',
                  detailUrl: require('@/assets/images/header/detail11.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel12'),
                  icon: require('@/assets/images/header/scene-icon12.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon12-active.svg'),
                  iconClass: 'w18',
                  desc: this.$t('message.header.sceneDesc12'),
                  routerPath: '/Device_Inspection_Maintenance_Manage',
                  detailUrl: require('@/assets/images/header/detail12.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel13'),
                  icon: require('@/assets/images/header/scene-icon13.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon13-active.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.sceneDesc13'),
                  routerPath: '/Property_Manage',
                  detailUrl: require('@/assets/images/header/detail13.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel14'),
                  icon: require('@/assets/images/header/scene-icon14.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon14-active.svg'),
                  iconClass: 'w18',
                  desc: this.$t('message.header.sceneDesc14'),
                  routerPath: '/Staff_Manage',
                  detailUrl: require('@/assets/images/header/detail14.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel15'),
                  icon: require('@/assets/images/header/scene-icon15.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon15-active.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.sceneDesc15'),
                  routerPath: '/Vehicle_Manage',
                  detailUrl: require('@/assets/images/header/detail15.png'),
                },
              ],
            },
          ],
        },
        {
          id: 'industrys',
          name: this.$t('message.header.firstNav3'), // 行业解决方案
          routerPath: '',
          children: [
            {
              id: 'industry1',
              routerPath: '',
              pid: 'second-industry1',
              name: this.$t('message.header.industryTitle'),
              children: [
                {
                  name: this.$t('message.header.industryName1'),
                  icon: `<svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 54 54"
                    width="54.000000"
                    height="54.000000"
                    fill="none"
                  >
                    <rect id="汽车 1" width="54.000000" height="54.000000" x="0.000000" y="0.000000" />
                    <path
                      id="矢量 128099"
                      d="M48.1376 24.6324L46.9631 24.6324L46.6138 23.4478L49.8268 23.4478C50.1832 23.4478 50.5304 23.335 50.8187 23.1255C51.107 22.9161 51.3216 22.6207 51.4317 22.2818C51.5418 21.9429 51.5418 21.5778 51.4317 21.2388C51.3216 20.8999 51.107 20.6046 50.8187 20.3951C50.5304 20.1856 50.1832 20.0728 49.8268 20.0728L45.6182 20.0728L43.7417 13.716C42.9874 11.6691 40.6856 10.125 38.3906 10.125L15.957 10.125C13.662 10.125 11.3619 11.6691 10.5722 13.8223L8.72944 20.0728L5.0625 20.0728C4.70613 20.0728 4.35892 20.1856 4.07061 20.3951C3.78231 20.6046 3.56772 20.8999 3.45759 21.2388C3.34747 21.5778 3.34747 21.9429 3.45759 22.2818C3.56772 22.6207 3.78231 22.9161 4.07061 23.1255C4.35892 23.335 4.70613 23.4478 5.0625 23.4478L7.73212 23.4478L7.38281 24.6324L6.75 24.6324C4.88869 24.6324 3.375 26.1461 3.375 28.0074L3.375 42.9283L6.06994 42.9283L6.06994 44.7643C6.06994 45.1207 6.18276 45.4679 6.39222 45.7562C6.60169 46.0445 6.89705 46.2591 7.23597 46.3692C7.57489 46.4793 7.93998 46.4793 8.2789 46.3692C8.61783 46.2591 8.91319 46.0445 9.12265 45.7562C9.33212 45.4679 9.44494 45.1207 9.44494 44.7643L9.44494 42.9283L45.8595 42.9283L45.8595 44.7643C45.8595 45.1207 45.9723 45.4679 46.1818 45.7562C46.3912 46.0445 46.6866 46.2591 47.0255 46.3692C47.3645 46.4793 47.7295 46.4793 48.0685 46.3692C48.4074 46.2591 48.7028 46.0445 48.9122 45.7562C49.1217 45.4679 49.2345 45.1207 49.2345 44.7643L49.2345 42.9283L51.5143 42.9283L51.5143 28.0074C51.5131 27.4152 51.3564 26.8336 51.0598 26.3209C50.7633 25.8082 50.3372 25.3824 49.8244 25.0861C49.3116 24.7897 48.7299 24.6333 48.1376 24.6324L48.1376 24.6324ZM6.75 39.5516L6.75 34.0166L10.6414 34.0166C12.0369 34.0166 13.3059 33.1374 13.7987 31.833L15.0677 28.4732C15.1251 28.3196 15.1318 28.1627 15.1436 28.0074L38.9019 28.0074C38.9137 28.1627 38.9205 28.3196 38.9779 28.4732L40.2469 31.8296C40.49 32.4708 40.922 33.0232 41.4858 33.4137C42.0495 33.8041 42.7184 34.0144 43.4042 34.0166L48.1376 34.0166L48.1376 39.5516L6.75 39.5516ZM48.1376 30.6416L43.4042 30.6399L42.4102 28.0057L48.1376 28.0057L48.1376 30.6416L48.1376 30.6416ZM11.5239 22.5146C11.6004 22.3556 11.6505 22.1852 11.6724 22.0101L13.7734 14.8837C14.0096 14.2425 15.0137 13.5 15.957 13.5L38.3906 13.5C39.3339 13.5 40.338 14.2425 40.5388 14.7757L43.4447 24.6307L10.9012 24.6307L11.5239 22.5146ZM11.637 28.0074L10.6414 30.6433L6.75 30.6433L6.75 28.0074L11.637 28.0074ZM32.4186 33.0244L22.4707 33.0244C22.1144 33.0244 21.7672 33.1372 21.4789 33.3467C21.1906 33.5561 20.976 33.8515 20.8658 34.1904C20.7557 34.5293 20.7557 34.8944 20.8658 35.2333C20.976 35.5723 21.1906 35.8676 21.4789 36.0771C21.7672 36.2866 22.1144 36.3994 22.4707 36.3994L32.4186 36.3994C32.7749 36.3994 33.1221 36.2866 33.4104 36.0771C33.6988 35.8676 33.9133 35.5723 34.0235 35.2333C34.1336 34.8944 34.1336 34.5293 34.0235 34.1904C33.9133 33.8515 33.6988 33.5561 33.4104 33.3467C33.1221 33.1372 32.7749 33.0244 32.4186 33.0244Z"
                      fill="rgb(255,255,255)"
                      fill-rule="nonzero"
                    />
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Vehicle_Industry',
                },
                {
                  name: this.$t('message.header.industryName2'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 54" width="54.000000" height="54.000000" fill="none">
                    <rect id="装备制造 1" width="54.000000" height="54.000000" x="0.000000" y="0.000000"/>
                    <path id="矢量 128104" d="M11.965 22.3708C10.7971 22.346 9.65624 22.0141 8.65726 21.4085C7.65828 20.8029 6.83637 19.9449 6.27418 18.9209C5.712 17.8969 5.42936 16.7428 5.45469 15.5749C5.42936 14.407 5.712 13.253 6.27418 12.2289C6.83637 11.2049 7.65828 10.3469 8.65726 9.74133C9.65624 9.13573 10.7971 8.80385 11.965 8.77905C13.133 8.80385 14.2738 9.13573 15.2728 9.74133C16.2717 10.3469 17.0937 11.2049 17.6558 12.2289C18.218 13.253 18.5007 14.407 18.4753 15.5749C18.5007 16.7428 18.218 17.8969 17.6558 18.9209C17.0937 19.9449 16.2717 20.8029 15.2728 21.4085C14.2738 22.0141 13.133 22.346 11.965 22.3708ZM11.965 11.6345C11.2982 11.6591 10.6497 11.8589 10.0847 12.2139C9.51971 12.5688 9.05821 13.0664 8.74667 13.6564C8.43514 14.2465 8.28456 14.9082 8.31009 15.5749C8.28456 16.2417 8.43514 16.9034 8.74667 17.4934C9.05821 18.0835 9.51971 18.581 10.0847 18.936C10.6497 19.2909 11.2982 19.4908 11.965 19.5154C12.6318 19.4908 13.2803 19.2909 13.8453 18.936C14.4103 18.581 14.8718 18.0835 15.1833 17.4934C15.4949 16.9034 15.6455 16.2417 15.6199 15.5749C15.6455 14.9082 15.4949 14.2465 15.1833 13.6564C14.8718 13.0664 14.4103 12.5688 13.8453 12.2139C13.2803 11.8589 12.6318 11.6591 11.965 11.6345L11.965 11.6345Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128105" d="M17.1324 26.5683L6.7102 26.5683C6.44909 26.5728 6.19212 26.5026 5.96954 26.3661C5.74696 26.2295 5.56803 26.0321 5.45382 25.7973L0.171324 16.2603C0.058839 16.0493 0 15.814 0 15.575C0 15.3359 0.0588389 15.1006 0.171324 14.8897L5.45382 5.26695C5.57465 5.03958 5.75588 4.84996 5.97755 4.71897C6.19923 4.58798 6.45274 4.5207 6.7102 4.52454L17.1324 4.52454C17.3857 4.52276 17.6345 4.59119 17.8512 4.72224C18.068 4.85329 18.2442 5.04183 18.3602 5.26695L23.757 14.8897C23.8694 15.1006 23.9283 15.3359 23.9283 15.575C23.9283 15.814 23.8694 16.0493 23.757 16.2603L18.4745 25.883C18.3451 26.1184 18.148 26.3096 17.9087 26.4317C17.6694 26.5539 17.399 26.6015 17.1324 26.5683ZM7.53827 23.7129L16.39 23.7129L20.873 15.575L16.39 7.37994L7.53826 7.37994L3.05528 15.575L7.53827 23.7129ZM49.2843 24.9121C49.0204 24.9061 48.7635 24.827 48.5419 24.6837L28.554 12.4626C28.3445 12.3365 28.1708 12.1587 28.0497 11.9462C27.9286 11.7337 27.8641 11.4936 27.8624 11.2491C27.8607 11.0045 27.9219 10.7636 28.0401 10.5494L31.4094 4.46743C31.4796 4.30176 31.5811 4.15118 31.7084 4.02395C31.8356 3.89672 31.9862 3.79523 32.1518 3.72503C32.3373 3.67064 32.5319 3.65524 32.7236 3.67982C32.9153 3.70439 33.0998 3.76839 33.2654 3.8678L53.2533 16.1175C53.4628 16.2436 53.6365 16.4214 53.7576 16.6339C53.8787 16.8464 53.9432 17.0864 53.9449 17.331C53.9466 17.5756 53.8854 17.8165 53.7672 18.0306L50.5406 24.1697C50.4482 24.3387 50.3219 24.4868 50.1696 24.6048C50.0173 24.7227 49.8422 24.8079 49.6555 24.855L49.2843 24.9121ZM31.0953 10.6351L48.7417 21.4L50.712 18.002L33.0656 7.15151L31.0953 10.6351Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128106" d="M35.7216 37.9898L35.3504 37.9898L22.8438 34.5918C22.6306 34.5346 22.4328 34.4306 22.2649 34.2874C22.0969 34.1441 21.963 33.9653 21.8729 33.7638C21.775 33.5688 21.724 33.3537 21.724 33.1356C21.724 32.9174 21.775 32.7023 21.8729 32.5074L32.3237 13.9758C32.4161 13.8068 32.5425 13.6587 32.6948 13.5408C32.8471 13.4229 33.0221 13.3377 33.2089 13.2905C33.3953 13.2326 33.5925 13.2179 33.7855 13.2476C33.9784 13.2773 34.1621 13.3506 34.3225 13.4618L45.1159 19.9722C45.3292 20.0948 45.5063 20.2714 45.6295 20.4843C45.7527 20.6972 45.8176 20.9388 45.8177 21.1847C45.8178 21.4307 45.753 21.6723 45.6299 21.8853L37.0637 37.1617C36.946 37.4163 36.756 37.6306 36.5174 37.7778C36.2787 37.9251 36.0019 37.9988 35.7216 37.9898L35.7216 37.9898ZM25.3851 32.2789L35.0078 34.7917L42.4604 21.6854L34.2654 16.6599L25.3851 32.2789ZM28.1263 50.3251C27.9172 50.3319 27.7102 50.2826 27.5266 50.1823L16.8189 45.1568C16.595 45.0395 16.4049 44.8669 16.2663 44.6556C16.1278 44.4442 16.0455 44.2009 16.0273 43.9489C16.0091 43.6968 16.0555 43.4443 16.1621 43.2151L19.1889 37.1046C19.2892 36.9103 19.4319 36.7411 19.6065 36.6096C19.7812 36.478 19.9832 36.3875 20.1975 36.3446C20.4119 36.3018 20.6332 36.3078 20.845 36.3622L33.266 39.7601C33.4796 39.8182 33.6764 39.9261 33.8402 40.075C34.0041 40.2239 34.1302 40.4096 34.2083 40.6167C34.3066 40.8166 34.3577 41.0364 34.3577 41.2592C34.3577 41.4819 34.3066 41.7017 34.2083 41.9017L29.4683 49.6398C29.3333 49.8702 29.1352 50.0571 28.8974 50.1786C28.6596 50.3 28.392 50.3508 28.1263 50.3251ZM19.3602 43.1866L27.5837 47.0699L30.6676 42.0159L21.2447 39.446L19.3602 43.1866Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Manufacturing_Industry',
                },
                {
                  name: this.$t('message.header.industryName3'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 54" width="54.000000" height="54.000000" fill="none">
                    <rect id="255Phone手机 1" width="54.000000" height="53.999996" x="0.000000" y="0.000000"/>
                    <path id="矢量 128115" d="M37.125 6.75L37.125 47.25L16.875 47.25L16.875 6.75L37.125 6.75ZM37.125 3.375L16.875 3.375C15.0187 3.375 13.5 4.89375 13.5 6.75L13.5 47.25C13.5 49.1063 15.0187 50.625 16.875 50.625L37.125 50.625C38.9812 50.625 40.5 49.1063 40.5 47.25L40.5 6.75C40.5 4.89375 38.9812 3.375 37.125 3.375ZM14.3438 10.125L14.3438 13.5L39.6562 13.5L39.6562 10.125L14.3438 10.125ZM14.3438 40.5L39.6562 40.5L39.6562 37.125L14.3438 37.125L14.3438 40.5ZM23.625 45.5625L30.375 45.5625L30.375 42.1875L23.625 42.1875L23.625 45.5625Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Electrical_Industry',
                },
                {
                  name: this.$t('message.header.industryName4'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 54" width="54.000000" height="54.000000" fill="none">
                    <rect id="机场贵宾厅 1" width="54.000000" height="54.000000" x="0.000000" y="0.000000"/>
                    <path id="矢量 128134" d="M18.6787 54.0001L18.5902 54.0001C18.059 54.0001 17.6164 53.7345 17.3508 53.2919L10.623 44.7935L0.708197 36.6493C0.265574 36.3837 0 35.9411 0 35.4099C0 34.8788 0.177049 34.4362 0.531148 34.0821L4.78033 29.6558C5.22295 29.2132 5.84262 29.0362 6.4623 29.1247L13.0131 30.6296L19.918 23.9017L2.92131 14.6952C2.47869 14.4296 2.12459 13.987 2.03607 13.4558C1.94754 12.9247 2.12459 12.3935 2.47869 11.9509L8.14426 5.84272C8.58689 5.4001 9.20656 5.22305 9.82623 5.31157L32.9311 10.623C36.6492 6.55092 45.4131 -2.56712 51.4328 2.30174C52.6721 3.36403 53.3803 4.6919 53.3803 6.28534C53.4688 9.91485 50.1934 14.6952 43.1115 21.246L48.6885 45.1476C48.8656 45.8558 48.6 46.4755 48.0689 46.9181L42.2262 51.6099C41.7836 51.964 41.2525 52.0526 40.8098 51.964C40.2787 51.8755 39.8361 51.5214 39.5705 51.0788L30.4525 34.7017L23.8131 41.3411L25.318 47.0067C25.4951 47.6263 25.318 48.3345 24.8754 48.7771L19.918 53.5575C19.5639 53.8231 19.1213 54.0001 18.6787 54.0001L18.6787 54.0001ZM4.3377 35.1444L12.9246 42.2263L13.1902 42.4919L18.8557 49.5739L21.6 46.9181L20.0951 41.2526C19.918 40.6329 20.0951 40.0132 20.5377 39.5706L29.5672 30.5411C29.9213 30.187 30.541 29.9214 31.0721 30.0099C31.6033 30.0985 32.1344 30.4526 32.4 30.8952L41.7836 47.5378L45.1475 44.8821L39.5705 20.9804C39.3934 20.3607 39.659 19.7411 40.1016 19.2985C48.6885 11.4198 49.9279 7.79025 49.8393 6.37386C49.8393 5.84271 49.6623 5.40009 49.1311 5.04599C46.741 3.09846 41.6066 6.19682 34.8787 13.7214C34.4361 14.164 33.8164 14.4296 33.1967 14.2526L10.0918 8.94108L6.63934 12.5706L23.7246 21.9542C24.2557 22.2198 24.5213 22.7509 24.6098 23.2821C24.6984 23.8132 24.5213 24.4329 24.0787 24.787L14.6951 33.905C14.2525 34.3476 13.6328 34.5247 13.1016 34.3476L6.55082 32.8427L4.3377 35.1444L4.3377 35.1444Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Spaceflight_Industry',
                },
                {
                  name: this.$t('message.header.industryName5'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 48 48" width="48.000000" height="48.000000" fill="none">
                    <rect id="设备保养管理-线性图标 1" width="48.000000" height="48.000000" x="0.000000" y="0.000000"/>
                    <path id="矢量 128100" d="M25.1996 7.10761C24.7381 6.27684 24.1843 5.44607 24.1843 5.44607C24.092 5.35376 24.092 5.35376 23.9996 5.35376C23.9073 5.35376 23.815 5.35376 23.815 5.44607C23.815 5.44607 23.2612 6.18453 22.7996 7.10761C22.1535 8.30761 21.7843 9.13838 21.7843 9.69222C21.7843 10.9845 22.7996 11.9999 24.092 11.9999C25.3843 11.9999 26.3996 10.9845 26.3996 9.69222C26.3073 9.13838 25.9381 8.30761 25.1996 7.10761ZM23.9996 11.0768C23.815 11.0768 23.7227 10.9845 23.7227 10.7999C23.7227 10.6153 23.815 10.523 23.9996 10.523C24.4612 10.523 24.8304 10.1538 24.8304 9.69222C24.8304 9.50761 24.9227 9.4153 25.1073 9.4153C25.292 9.4153 25.3843 9.50761 25.3843 9.69222C25.3843 10.4307 24.7381 11.0768 23.9997 11.0768L23.9996 11.0768ZM32.7689 19.9384C32.5843 19.7538 32.3073 19.6615 32.1227 19.6615C31.5689 19.6615 31.015 19.3845 30.7381 18.8307C30.4612 18.3691 30.4612 17.723 30.7381 17.2615C30.8304 17.0768 30.9227 16.7999 30.8304 16.523C30.7381 16.2461 30.6458 16.0615 30.3689 15.9691L26.8612 13.9384C26.6766 13.8461 26.3997 13.8461 26.215 13.8461C25.9381 13.9384 25.7535 14.0307 25.6612 14.3076C25.3843 14.7691 24.8304 15.1384 24.2766 15.1384C23.7227 15.1384 23.0766 14.7691 22.892 14.3999C22.7997 14.2153 22.5227 14.0307 22.3381 13.9384C22.0612 13.8461 21.8766 13.9384 21.5997 14.0307L18.092 16.0615C17.9073 16.1538 17.7227 16.4307 17.6304 16.6153C17.5381 16.8922 17.6304 17.0768 17.7227 17.3538C17.9073 17.723 17.9997 18.0922 17.9073 18.5538C17.815 19.0153 17.5381 19.2922 17.1689 19.5691C16.892 19.7538 16.615 19.7538 16.3381 19.7538C16.0612 19.7538 15.8766 19.8461 15.692 20.0307C15.5073 20.2153 15.415 20.4922 15.415 20.6768L15.415 24.7384C15.415 25.0153 15.5073 25.1999 15.692 25.3845C15.8766 25.5691 16.1535 25.6615 16.3381 25.6615C17.2612 25.6615 17.9073 26.3999 17.9073 27.2307C17.9073 27.5076 17.815 27.7845 17.7227 28.0615C17.6304 28.2461 17.5381 28.523 17.6304 28.7999C17.7227 29.0768 17.815 29.2615 18.092 29.3538L21.5997 31.3845C21.7843 31.4768 22.0612 31.5691 22.3381 31.4768C22.615 31.3845 22.7997 31.2922 22.892 31.0153C23.0766 30.6461 23.4458 30.3691 23.9073 30.2768C24.2766 30.1845 24.7381 30.1845 25.1073 30.4615C25.3843 30.5538 25.5689 30.8307 25.6612 31.0153C25.8458 31.2922 26.1227 31.4768 26.492 31.4768C26.6766 31.4768 26.8612 31.3845 26.9535 31.3845L30.4612 29.3538C30.6458 29.2615 30.8304 28.9845 30.9227 28.7999C31.015 28.523 30.9227 28.3384 30.8304 28.0615C30.6458 27.6922 30.5535 27.2307 30.6458 26.8615C30.7381 26.4922 31.015 26.123 31.3843 25.8461C31.6612 25.6615 31.9381 25.6615 32.215 25.6615C32.492 25.6615 32.6766 25.5691 32.8612 25.3845C33.0458 25.1999 33.1381 24.923 33.1381 24.7384L33.1381 20.6768C33.0458 20.3999 32.9535 20.123 32.7689 19.9384ZM28.7073 28.0615L26.6766 29.2615C26.492 29.0768 26.215 28.8922 26.0304 28.7076C25.4766 28.4307 24.9227 28.2461 24.2766 28.2461C23.9996 28.2461 23.6304 28.2461 23.3535 28.3384C22.7996 28.523 22.2458 28.7999 21.7843 29.1691L19.7535 27.9691C19.8458 27.6922 19.8458 27.4153 19.8458 27.1384C19.8458 25.5691 18.7381 24.1845 17.2612 23.723L17.2612 21.323C17.5381 21.2307 17.815 21.1384 18.092 20.9538C18.9227 20.4922 19.4766 19.7538 19.7535 18.8307C19.9381 18.2768 19.9381 17.6307 19.7535 17.0768L21.8766 15.8768C22.5227 16.523 23.4458 16.8922 24.2766 16.8922C25.1996 16.8922 26.0304 16.523 26.6766 15.8768L28.7073 17.0768C28.5227 17.9999 28.615 18.923 29.0766 19.6615C29.5381 20.3999 30.2766 21.0461 31.1996 21.323L31.1996 23.723C30.9227 23.8153 30.6458 23.9076 30.3689 24.0922C29.0766 25.0153 28.3381 26.5845 28.7073 28.0615L28.7073 28.0615Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128101" d="M24.1849 19.2C22.2465 19.2 20.7695 20.7692 20.7695 22.6153C20.7695 24.5538 22.3388 26.0307 24.1849 26.0307C26.0311 26.0307 27.6003 24.4615 27.6003 22.6153C27.6926 20.7692 26.1234 19.2 24.1849 19.2L24.1849 19.2ZM25.7541 22.7076C25.7541 23.5384 25.0157 24.2769 24.1849 24.2769C23.3541 24.2769 22.6157 23.5384 22.6157 22.7076C22.6157 21.8769 23.3541 21.1384 24.1849 21.1384C25.108 21.1384 25.7541 21.7846 25.7541 22.7076Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128102" d="M10.6154 25.2923L10.6154 12.923L19.3846 12.923C19.5692 12.923 19.8462 12.7384 19.8462 12.4615L19.8462 11.5384C19.8462 11.3538 19.6615 11.0769 19.3846 11.0769L10.6154 11.0769L10.6154 8.49226L19.4769 8.49226C19.6615 8.49226 19.8462 8.30764 19.8462 8.12303L19.8462 7.19995C19.8462 7.01533 19.6615 6.83072 19.4769 6.83072L10.6154 6.83072L10.6154 4.33841C10.6154 3.23072 9.69231 2.30764 8.58462 2.30764L5.63077 2.30764C4.52308 2.30764 3.6 3.23072 3.6 4.33841L3.6 27.9692C2.58462 28.1538 1.84615 29.0769 1.84615 30.0923L1.84615 33.2307C0.738462 33.5076 0 34.3384 0 35.3538L0 43.5692C0 44.123 0.184615 44.6769 0.646154 45.0461C0.923077 45.4153 1.38462 45.6 1.84615 45.6923L45.7846 45.6923C46.9846 45.6923 47.9077 44.7692 47.9077 43.5692L47.9077 35.3538C47.9077 34.3384 47.1692 33.4153 46.1539 33.323L46.1539 30.1846C46.1539 29.0769 45.4154 28.2461 44.4 28.0615L44.4 4.33841C44.4 3.78456 44.2154 3.23072 43.7539 2.86149C43.3846 2.49226 42.8308 2.21533 42.2769 2.21533L39.3231 2.21533C38.2154 2.21533 37.2923 3.13841 37.2923 4.2461L37.2923 6.6461L28.4308 6.6461C28.2462 6.6461 28.0615 6.83072 28.0615 7.01533L28.0615 7.93841C28.0615 8.12303 28.2462 8.30764 28.4308 8.30764L37.2923 8.30764L37.2923 10.9846L28.4308 10.9846C28.2462 10.9846 28.0615 11.1692 28.0615 11.3538L28.0615 12.2769C28.0615 12.4615 28.2462 12.6461 28.4308 12.6461L37.2923 12.6461L37.2923 27.6923C37.2923 28.8 38.2154 29.723 39.3231 29.723L43.9385 29.723C44.2154 29.723 44.4 29.9076 44.4 30.1846L44.4 33.323L3.50769 33.323L3.50769 30.1846C3.50769 29.9076 3.69231 29.723 3.96923 29.723L8.58462 29.723C9.69231 29.723 10.6154 28.7999 10.6154 27.6923L10.6154 25.2923ZM42.2769 27.9692L39.6 27.9692C39.4154 27.9692 39.2308 27.7846 39.2308 27.5999L39.2308 4.33841C39.2308 4.15379 39.3231 4.06149 39.5077 4.06149L42.4615 4.06149C42.5539 4.06149 42.6462 4.06149 42.6462 4.15379C42.7385 4.2461 42.7385 4.2461 42.7385 4.33841L42.7385 27.5076C42.7385 27.7846 42.5539 27.9692 42.2769 27.9692ZM5.35385 4.33841C5.35385 4.15379 5.44615 4.06149 5.63077 4.06149L8.58462 4.06149C8.76923 4.06149 8.86154 4.15379 8.86154 4.33841L8.86154 27.5076C8.86154 27.6923 8.67692 27.8769 8.49231 27.8769L5.81539 27.8769C5.53846 27.8769 5.26154 27.6 5.26154 27.323L5.26154 4.33841L5.35385 4.33841ZM46.2462 43.5692C46.2462 43.7538 46.0615 43.9384 45.8769 43.9384L2.12308 43.9384C1.93846 43.9384 1.75385 43.7538 1.75385 43.5692L1.75385 35.3538C1.75385 35.1692 1.93846 34.9846 2.12308 34.9846L45.8769 34.9846C46.0615 34.9846 46.2462 35.1692 46.2462 35.3538L46.2462 43.5692L46.2462 43.5692Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Auto_Parts_Industry',
                },
                {
                  name: this.$t('message.header.industryName6'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 62" width="54.000000" height="62.000000" fill="none">
                    <rect id="医疗服务 1" width="54.000000" height="62.000000" x="0.000000" y="0.000000"/>
                    <path id="矢量 128110" d="M36.5625 8.39575L36.5625 17.4374L46.6875 17.4374L46.6875 53.6041L7.3125 53.6041L7.3125 17.4374L17.4375 17.4374L17.4375 8.39575L36.5625 8.39575L36.5625 8.39575ZM43.3125 21.3124L10.6875 21.3124L10.6875 49.7291L43.3125 49.7291L43.3125 21.3124L43.3125 21.3124ZM28.6796 26.47L28.6796 33.5833L34.875 33.5833L34.875 37.4583L28.6796 37.4583L28.6796 44.5715L25.3046 44.5715L25.3046 37.4583L19.1093 37.4583L19.1093 33.5833L25.3046 33.5833L25.3046 26.47L28.6796 26.47ZM33.1875 12.2708L20.8125 12.2708L20.8125 17.4374L33.1875 17.4374L33.1875 12.2708L33.1875 12.2708Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  // 生物医疗
                  routerPath: '/Biomedical_Industry',
                },
                {
                  name: this.$t('message.header.industryName7'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 54" width="54.000000" height="54.000000" fill="none">
                    <rect id="电商-壹米滴答 1" width="54.000000" height="54.000000" x="0.000000" y="0.000000"/>
                    <path id="矢量 128116" d="M45.818 47.4546L9.818 47.4546C9.3271 47.4546 8.99982 47.2909 8.67255 46.9637C8.34528 46.6364 8.18164 46.1455 8.18164 45.6546L10.6362 12.9273C10.6362 12.1091 11.4544 11.4546 12.2726 11.4546L43.3635 11.4546C44.1816 11.4546 44.9998 12.1091 44.9998 12.9273L47.4544 45.6546C47.4544 46.1455 47.2907 46.6364 46.9635 46.9637C46.6362 47.2909 46.3089 47.4546 45.818 47.4546ZM11.618 44.1819L44.018 44.1819L41.8907 14.7273L13.7453 14.7273L11.618 44.1819Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128117" d="M28.1458 28.1456C23.4004 28.1456 19.6367 24.2184 19.6367 19.6365C19.6367 19.1456 19.964 18.8184 20.4549 18.8184C20.9458 18.8184 21.2731 19.1456 21.2731 19.6365C21.2731 23.4002 24.3822 26.5093 28.1458 26.5093C31.9094 26.5093 35.0185 23.4002 35.0185 19.6365C35.0185 19.1456 35.3458 18.8184 35.8367 18.8184C36.3276 18.8184 36.6549 19.1456 36.6549 19.6365C36.8185 24.382 32.8913 28.1456 28.1458 28.1456Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128118" d="M27.818 14.7273C26.8362 14.7273 26.1816 14.0727 26.1816 13.0909L26.1816 10.6364C26.1816 9.65455 26.8362 9 27.818 9C28.7998 9 29.4544 9.65455 29.4544 10.6364L29.4544 13.0909C29.4544 14.0727 28.7998 14.7273 27.818 14.7273L27.818 14.7273Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  class: 'special',
                  routerPath: '/Logistics_Industry',
                },
                {
                  name: this.$t('message.header.industryName8'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 46 46" width="46.000000" height="46.000000" fill="none">
                    <rect id="地铁 1" width="46.000000" height="46.000000" x="0.000000" y="0.000000"/>
                    <path id="矢量 128131" d="M37.0206 0C39.6624 0 41.8046 2.13102 41.8046 4.75865L41.8046 34.3676C41.803 35.1349 41.6161 35.8905 41.2599 36.5701C40.9037 37.2497 40.3888 37.8333 39.7587 38.2713C39.1287 38.7093 38.4023 38.9888 37.6412 39.0859L44.5919 46L40.0811 46L33.1707 39.1263L12.8275 39.1263L5.91808 46L1.4082 46L8.41522 39.0296C7.70186 38.8847 7.03117 38.5783 6.45457 38.134C5.87797 37.6897 5.41078 37.1192 5.08882 36.4663C4.76687 35.8135 4.59871 35.0956 4.59722 34.3676L4.59722 4.75959C4.59722 2.13008 6.74045 0 9.38122 0L37.0206 0ZM38.6156 25.9083L7.78624 25.9083L7.78624 34.3676C7.78624 35.2435 8.49971 35.9542 9.38122 35.9542L37.0206 35.9542C37.9012 35.9542 38.6156 35.2435 38.6156 34.3676L38.6156 25.9083ZM13.6339 29.0804C14.3933 29.0804 15.0955 29.4841 15.4748 30.1375C15.6614 30.4587 15.7596 30.8236 15.7596 31.195C15.7596 31.5665 15.6614 31.9314 15.4748 32.2526C15.2874 32.5747 15.0188 32.8419 14.6957 33.0276C14.3726 33.2132 14.0065 33.3108 13.6339 33.3106C13.2616 33.3116 12.8957 33.2145 12.5728 33.0293C12.2499 32.844 11.9815 32.577 11.7945 32.2551C11.6075 31.9332 11.5085 31.5678 11.5075 31.1955C11.5085 30.8232 11.6075 30.4578 11.7945 30.1359C11.9815 29.814 12.2499 29.547 12.5728 29.3617C12.8957 29.1765 13.2616 29.0795 13.6339 29.0804ZM32.7689 29.0804C33.5284 29.0804 34.2306 29.4841 34.6099 30.1375C34.7964 30.4587 34.8947 30.8236 34.8947 31.195C34.8947 31.5665 34.7964 31.9314 34.6099 32.2526C34.4225 32.5747 34.1538 32.8419 33.8308 33.0276C33.5077 33.2132 33.1416 33.3108 32.7689 33.3106C32.3967 33.3116 32.0307 33.2145 31.7078 33.0293C31.3849 32.844 31.1165 32.577 30.9295 32.2551C30.7426 31.9332 30.6436 31.5678 30.6426 31.1955C30.6436 30.8232 30.7426 30.4578 30.9295 30.1359C31.1165 29.814 31.3849 29.547 31.7078 29.3617C32.0307 29.1765 32.3967 29.0795 32.7689 29.0804ZM21.6069 11.1029L7.7853 11.1029L7.7853 22.7353L21.605 22.7353L21.605 11.1038L21.6069 11.1029ZM38.6156 11.1029L24.7959 11.1029L24.7959 22.7353L38.6147 22.7353L38.6147 11.1038L38.6156 11.1029ZM37.0206 3.17306L9.38122 3.17306C8.50065 3.17306 7.78624 3.88371 7.78624 4.75959L7.78624 7.93265L38.6156 7.93265L38.6156 4.75959C38.6156 3.88371 37.9022 3.17306 37.0207 3.17306L37.0206 3.17306Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Transport_Industry',
                },
                {
                  name: this.$t('message.header.industryName9'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 51 52" width="51.000000" height="52.000000" fill="none">
                    <rect id="园区运维 7" width="51.000000" height="52.000000" x="0.000000" y="0.000000" />
                    <path
                      id="矢量 124"
                      d="M33.0013 34.1136C32.7634 33.871 32.4562 33.7114 32.1238 33.6577C31.7914 33.604 31.4509 33.659 31.1511 33.8148C30.8513 33.9706 30.6075 34.2191 30.4547 34.5248C30.3019 34.8306 30.248 35.1777 30.3006 35.5166C30.3533 35.8555 30.5098 36.1687 30.7477 36.4113L36.3259 42.0988C36.5638 42.3415 36.871 42.501 37.2034 42.5547C37.5358 42.6084 37.8763 42.5534 38.1761 42.3976C38.4759 42.2419 38.7197 41.9933 38.8725 41.6876C39.0253 41.3819 39.0792 41.0347 39.0265 40.6958C38.9739 40.3569 38.8174 40.0437 38.5794 39.8011L33.0013 34.1136ZM35.5051 29.0273C35.8482 26.8428 35.6193 24.6046 34.8415 22.5392C34.0638 20.4738 32.7649 18.6545 31.0762 17.2653C29.3875 15.8761 27.3689 14.9662 25.2246 14.6279C23.0802 14.2895 20.8863 14.5346 18.8647 15.3383C18.6176 15.4361 18.3982 15.5952 18.2266 15.8013C18.0551 16.0074 17.9367 16.2539 17.8822 16.5184C17.8278 16.783 17.839 17.0572 17.9148 17.3162C17.9906 17.5753 18.1287 17.8109 18.3165 18.0017L23.1886 22.9693C23.3866 23.1709 23.529 23.4221 23.6015 23.6976C23.674 23.9731 23.674 24.2633 23.6015 24.5388C23.529 24.8143 23.3866 25.0655 23.1886 25.2671L21.6283 26.858C21.4306 27.0598 21.1843 27.2051 20.914 27.279C20.6438 27.3529 20.3592 27.3529 20.089 27.279C19.8188 27.2051 19.5724 27.0598 19.3747 26.858L14.4867 21.8741C14.2999 21.6835 14.0695 21.5434 13.8164 21.4662C13.5632 21.389 13.2952 21.3771 13.0365 21.4318C12.7777 21.4864 12.5363 21.6058 12.3341 21.7791C12.1318 21.9525 11.975 22.1744 11.8777 22.425C11.079 24.4826 10.8276 26.7189 11.1489 28.9074C11.4703 31.096 12.353 33.1592 13.7077 34.8881C15.0624 36.6171 16.841 37.9504 18.8636 38.7532C20.8861 39.556 23.0808 39.7998 25.2254 39.4598L32.4881 46.865C33.3882 47.7831 34.5094 48.4435 35.7392 48.7798C36.969 49.116 38.2639 49.1161 39.4937 48.7803C40.7235 48.4444 41.845 47.7843 42.7453 46.8664C43.6456 45.9484 44.293 44.805 44.6224 43.551C44.9518 42.2971 44.9516 40.9768 44.6219 39.7229C44.2921 38.469 43.6444 37.3258 42.7439 36.4081L35.5051 29.0273ZM40.4903 44.5672C39.9859 45.0815 39.3576 45.4513 38.6686 45.6395C37.9796 45.8277 37.2541 45.8277 36.565 45.6395C35.876 45.4513 35.2477 45.0815 34.7433 44.5672L26.2597 35.9173L25.3991 36.1205C23.9931 36.4527 22.53 36.4405 21.1295 36.0847C19.7291 35.729 18.4313 35.0399 17.3425 34.0739C16.2538 33.1079 15.4051 31.8926 14.866 30.5276C14.3269 29.1625 14.1128 27.6867 14.2413 26.221L17.1212 29.1573C17.7147 29.7626 18.4539 30.1978 19.2647 30.4193C20.0755 30.6409 20.9292 30.6409 21.7399 30.4193C22.5507 30.1978 23.29 29.7626 23.8835 29.1573L25.4437 27.5665C26.0373 26.9613 26.4642 26.2076 26.6815 25.3809C26.8987 24.5542 26.8987 23.6838 26.6815 22.8571C26.4642 22.0305 26.0373 21.2767 25.4437 20.6716L22.5925 17.7645C24.0294 17.6438 25.4738 17.8717 26.8077 18.4295C28.1416 18.9873 29.327 19.8592 30.2669 20.9739C31.2068 22.0885 31.8746 23.4142 32.2155 24.8425C32.5564 26.2708 32.5608 27.7611 32.2283 29.1915L32.0243 30.0738L40.4919 38.7075C42.0761 40.326 42.0761 42.9487 40.4903 44.5672L40.4903 44.5672ZM47.0486 21.4971L28.9596 3.05333C28.3657 2.44889 27.6263 2.01428 26.8157 1.79309C26.0051 1.5719 25.1517 1.5719 24.3411 1.79309C23.5305 2.01428 22.7912 2.44889 22.1973 3.05333L4.10821 21.4971C3.43734 22.1818 2.98146 23.0545 2.79858 24.0042C2.61571 24.9539 2.71413 25.9376 3.08131 26.8301C3.44849 27.7226 4.06782 28.4835 4.86046 29.016L4.86046 45.5C4.86046 48.1877 7.00565 50.375 9.64171 50.375L25.5792 50.375C25.9158 50.375 26.2437 50.2663 26.516 50.0646C26.7883 49.8629 26.991 49.5785 27.095 49.2521C27.199 48.9257 27.199 48.5742 27.095 48.2478C26.991 47.9214 26.7883 47.637 26.516 47.4353C26.2437 47.2336 25.9158 47.125 25.5792 47.125L9.64171 47.125C8.76356 47.125 8.04796 46.397 8.04796 45.5L8.04796 28.0182C8.04796 27.3243 7.61606 26.7068 6.97218 26.481C6.71628 26.3915 6.48692 26.2372 6.30568 26.0324C6.12445 25.8276 5.99732 25.5792 5.93626 25.3105C5.8752 25.0418 5.88222 24.7617 5.95667 24.4965C6.03111 24.2314 6.17052 23.9899 6.36178 23.7948L24.4508 5.35108C24.649 5.14964 24.8955 5.00482 25.1658 4.93111C25.4361 4.85741 25.7207 4.85741 25.991 4.93111C26.2613 5.00482 26.5079 5.14964 26.706 5.35108L44.7951 23.7965C45.0963 24.102 45.262 24.5098 45.262 24.9453C45.2632 25.284 45.16 25.6144 44.967 25.89C44.7739 26.1656 44.5008 26.3723 44.1862 26.481C43.8721 26.5909 43.5994 26.7982 43.4062 27.0737C43.2131 27.3493 43.1091 27.6795 43.1089 28.0182L43.1089 31.9052C43.1089 32.2484 43.2154 32.5827 43.4132 32.8604C43.6111 33.138 43.89 33.3446 44.2101 33.4507C44.5302 33.5567 44.875 33.5567 45.1951 33.4507C45.5152 33.3446 45.7942 33.138 45.992 32.8604C46.1898 32.5827 46.2964 32.2484 46.2964 31.9052L46.2964 29.0176C46.9597 28.5755 47.5041 27.9715 47.8802 27.2603C48.2562 26.5491 48.4519 25.7533 48.4495 24.9453C48.4495 23.6421 47.9523 22.4168 47.0486 21.4971Z"
                      fill="rgb(0,0,0)"
                      fill-rule="nonzero"
                    />
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Machinery_Industry',
                },
                {
                  name: this.$t('message.header.industryName10'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 61" width="54.000000" height="61.000000" fill="none">
                    <rect id="饮料 1" width="54.000000" height="61.000000" x="0.000000" y="0.000000"/>
                    <path id="矢量 128111" d="M16.3829 4.79932L27.0012 4.79932L27.0012 8.22446L16.3829 8.22446L16.3829 4.79932ZM45.2029 21.9336L40.9456 9.93794L13.0544 9.93794L8.79883 21.9336L11.1866 21.9336L14.226 56.2005L39.7755 56.2005L42.815 21.9336L45.2029 21.9336L45.2029 21.9336ZM38.8898 13.3664L40.7147 18.5051L13.287 18.5051L15.1103 13.3664L38.8898 13.3664L38.8898 13.3664ZM15.3059 33.926L38.6943 33.926L38.238 39.0661L15.7622 39.0661L15.3059 33.926ZM16.9784 52.7754L16.0658 42.493L37.9329 42.493L37.0233 52.7754L16.9784 52.7754ZM38.9994 30.5008L15.0023 30.5008L14.2424 21.9336L39.7578 21.9336L38.9994 30.5008Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Daily_Chemicals_Industry',
                },
                {
                  name: this.$t('message.header.industryName11'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 54" width="54.000000" height="54.000000" fill="none">
                    <rect id="钢厂-steel-mill-bold 1" width="54.000000" height="53.999996" x="0.000000" y="0.000000"/>
                    <path id="矢量 128124" d="M20.3508 14.0873C21.4645 14.0873 22.3842 14.953 22.4551 16.0634L23.5013 32.5165L27.5902 31.5968L28.6685 24.3321C28.7205 23.9817 28.8815 23.6565 29.1287 23.4027C29.3758 23.1489 29.6966 22.9793 30.0455 22.918L30.2429 22.8944L40.2548 22.3341C40.5199 22.3194 40.7846 22.3674 41.0276 22.4742C41.2706 22.581 41.485 22.7437 41.6533 22.9489C41.8216 23.1542 41.9392 23.3962 41.9963 23.6554L42.9008 27.751L45.589 27.157C46.8715 26.8532 48.154 27.5822 48.5708 28.804L48.6383 29.0402C48.6839 29.2292 48.7058 29.4267 48.7058 29.6427L48.5118 45.9827C48.5118 47.3817 47.3761 48.5157 45.9738 48.5157L22.72 48.4701C22.6441 48.4701 22.5699 48.465 22.4973 48.4549L22.3792 48.4667L22.2864 48.4701L7.44141 48.4701C6.27535 48.4701 5.33035 47.5251 5.33203 46.2865L5.33878 46.1751L7.99491 16.0127C8.02566 15.6646 8.14241 15.3296 8.33466 15.0378C8.52691 14.746 8.78865 14.5066 9.09636 14.3409C9.40406 14.1753 9.74809 14.0887 10.0975 14.089L20.3508 14.0873ZM39.0095 25.7834L31.8038 26.1867L30.7593 33.237C30.7143 33.539 30.5881 33.8231 30.3944 34.0591C30.2006 34.295 29.9465 34.474 29.659 34.5769L29.4599 34.636L24.119 35.8358L24.3653 45.0985L45.1452 45.1373L45.319 30.672L42.0453 31.3977L41.8563 31.4348C41.5773 31.4747 41.2928 31.4441 41.0287 31.3458C40.7646 31.2475 40.5293 31.0846 40.3443 30.872C40.1593 30.6594 40.0305 30.4038 39.9697 30.1287L39.0078 25.7834L39.0095 25.7834ZM19.5323 23.2656L10.7438 23.2656L8.8201 45.0951L20.9228 45.0968L19.5323 23.2656L19.5323 23.2656ZM19.1611 17.4623L11.2552 17.4623L11.0408 19.8923L19.318 19.8923L19.1628 17.4623L19.1611 17.4623ZM26.1254 3.94879C26.4649 3.98908 26.7841 4.13152 27.0408 4.35725C27.2975 4.58298 27.4797 4.88136 27.5631 5.21288C27.6464 5.54441 27.6272 5.89344 27.5078 6.21377C27.3884 6.53411 27.1746 6.81063 26.8946 7.00674C26.6146 7.20285 26.2816 7.30929 25.9398 7.31198L25.7423 7.30185C24.956 7.21073 24.367 7.38623 23.8507 7.83848C23.665 7.99672 23.5261 8.20271 23.449 8.43416L23.1335 9.28467L23.093 9.38423C22.7509 10.2451 22.1716 10.9912 21.4223 11.5358C19.7686 12.7778 17.8718 12.7778 16.1573 11.5628C15.8764 11.3531 15.6678 11.0612 15.5604 10.7275C15.453 10.3938 15.4521 10.035 15.558 9.70081C15.6638 9.36664 15.8711 9.07373 16.1511 8.86277C16.431 8.6518 16.7697 8.53325 17.1201 8.52357C17.4705 8.5139 17.8153 8.61359 18.1064 8.80879C18.6397 9.18679 18.9282 9.18679 19.3957 8.83579C19.6043 8.69213 19.7742 8.49908 19.8901 8.27385L20.0082 8.00385L20.1263 7.68323C20.5145 6.58635 20.8368 5.99067 21.6232 5.30048C22.8702 4.20867 24.4109 3.75304 26.1237 3.94879L26.1254 3.94879ZM17.5985 3.84079C17.9502 3.88406 18.2793 4.03696 18.5393 4.2778C18.7992 4.51864 18.9768 4.8352 19.0467 5.1826C19.1166 5.52999 19.0754 5.89059 18.929 6.21326C18.7825 6.53592 18.5381 6.80429 18.2306 6.9803C17.923 7.1563 17.5678 7.23102 17.2154 7.19385C16.429 7.10442 15.8384 7.27823 15.322 7.73217C15.0993 7.92792 15.0149 8.04773 14.8799 8.38185L14.8023 8.58773C14.3821 9.7116 13.972 10.3579 12.9646 11.1139C11.3092 12.3542 9.41241 12.3542 7.6996 11.1392C7.42381 10.9277 7.22007 10.6362 7.11623 10.3045C7.01238 9.97276 7.01348 9.61709 7.1194 9.28604C7.22531 8.955 7.43086 8.66474 7.70796 8.45492C7.98506 8.2451 8.32019 8.12597 8.66755 8.1138C9.01491 8.10162 9.35755 8.19701 9.64866 8.38692C10.1802 8.76323 10.4705 8.76323 10.9379 8.41392C11.2923 8.14729 11.3986 8.01567 11.5623 7.60392L11.645 7.3896C12.0044 6.42773 12.3335 5.86242 13.0962 5.19585C14.3416 4.10067 15.884 3.64504 17.5968 3.84079L17.5985 3.84079Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Chemical_Industry',
                },
                {
                  name: this.$t('message.header.industryName12'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 54" width="54.000000" height="54.000000" fill="none">
                    <rect id="司法类_监狱 1" width="54.000000" height="54.000000" x="0.000000" y="0.000000"/>
                    <path id="矢量 128138" d="M47.25 13.5L47.25 3.375L37.125 3.375L37.125 10.125L30.375 10.125L30.375 3.375L20.25 3.375L20.25 10.125L13.5 10.125L13.5 3.375L3.375 3.375L3.375 13.5L6.75 13.5L6.75 47.25L3.375 47.25L3.375 50.625L6.75 50.625L16.9459 50.625L33.8209 50.625L43.875 50.625L47.25 50.625L47.25 47.25L43.875 47.25L43.875 13.5L47.25 13.5ZM40.5 6.75L43.875 6.75L43.875 10.125L40.5 10.125L40.5 6.75ZM23.625 6.75L27 6.75L27 10.125L23.625 10.125L23.625 6.75ZM6.75 6.75L10.125 6.75L10.125 10.125L6.75 10.125L6.75 6.75ZM20.25 47.25L20.25 30.375L30.375 30.375L30.375 47.25L20.25 47.25ZM40.5 47.25L33.75 47.25L33.75 27L16.875 27L16.875 47.25L10.125 47.25L10.125 13.5L13.5 13.5L20.25 13.5L30.375 13.5L37.125 13.5L40.5 13.5L40.5 47.25ZM13.5 16.875L16.875 16.875L16.875 20.25L13.5 20.25L13.5 16.875ZM23.625 16.875L27 16.875L27 20.25L23.625 20.25L23.625 16.875ZM33.75 16.875L37.125 16.875L37.125 20.25L33.75 20.25L33.75 16.875Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Municipal_Public_Service_Industry',
                },
                {
                  name: this.$t('message.header.industryName13'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 54" width="54.000000" height="54.000000" fill="none">
                    <rect id="洗衣机 1" width="54.000000" height="54.000000" x="0.000000" y="0.000000"/>
                    <path id="矢量 128103" d="M43.875 1.6875L10.125 1.6875C8.26369 1.6875 6.75 3.20119 6.75 5.0625L6.75 48.9375C6.75 50.7988 8.26369 52.3125 10.125 52.3125L43.875 52.3125C45.7363 52.3125 47.25 50.7988 47.25 48.9375L47.25 5.0625C47.25 3.20119 45.7363 1.6875 43.875 1.6875ZM10.125 5.0625L43.875 5.0625L43.875 12.1635L10.125 12.1635L10.125 5.0625ZM10.125 48.9375L10.125 15.5385L43.875 15.5385L43.8784 48.9375L10.125 48.9375ZM27 18.5625C19.5564 18.5625 13.5 24.6189 13.5 32.0625C13.5 39.5061 19.5564 45.5625 27 45.5625C34.4436 45.5625 40.5 39.5061 40.5 32.0625C40.5 24.6189 34.4436 18.5625 27 18.5625ZM27 42.1875C21.4161 42.1875 16.875 37.6464 16.875 32.0625C16.875 26.4786 21.4161 21.9375 27 21.9375C32.5839 21.9375 37.125 26.4786 37.125 32.0625C37.125 37.6464 32.5839 42.1875 27 42.1875ZM23.8241 24.597C22.8628 24.9942 21.9899 25.5781 21.2557 26.3149C20.5182 27.0494 19.9337 27.923 19.5362 28.8849C19.4304 29.1413 19.3893 29.4197 19.4165 29.6956C19.4438 29.9716 19.5386 30.2366 19.6925 30.4673C19.8465 30.6979 20.0548 30.8871 20.2992 31.0182C20.5436 31.1492 20.8164 31.2181 21.0938 31.2187C21.4276 31.2193 21.754 31.1206 22.0317 30.9352C22.3093 30.7498 22.5256 30.4861 22.653 30.1776C22.8812 29.6253 23.2161 29.1236 23.6386 28.7011C24.0611 28.2786 24.5628 27.9437 25.1151 27.7155C25.4443 27.5792 25.722 27.3421 25.9083 27.0383C26.0946 26.7345 26.1799 26.3795 26.152 26.0242C26.1241 25.6689 25.9845 25.3316 25.7531 25.0605C25.5217 24.7895 25.2104 24.5987 24.8639 24.5154C24.5174 24.4321 24.1534 24.4607 23.8241 24.597L23.8241 24.597ZM40.5 7.101L33.75 7.101C33.3936 7.101 33.0464 7.21382 32.7581 7.42328C32.4698 7.63275 32.2552 7.92811 32.1451 8.26703C32.035 8.60596 32.035 8.97104 32.1451 9.30997C32.2552 9.64889 32.4698 9.94425 32.7581 10.1537C33.0464 10.3632 33.3936 10.476 33.75 10.476L40.5 10.476C40.8564 10.476 41.2036 10.3632 41.4919 10.1537C41.7802 9.94425 41.9948 9.64889 42.1049 9.30997C42.215 8.97104 42.215 8.60596 42.1049 8.26703C41.9948 7.92811 41.7802 7.63275 41.4919 7.42328C41.2036 7.21382 40.8564 7.101 40.5 7.101Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Home_Appliance_Industry',
                },
                {
                  name: this.$t('message.header.industryName14'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 54" width="54.000000" height="54.000000" fill="none">
                    <rect id="冶金矿产 1" width="54.000000" height="53.999996" x="0.000000" y="0.000000"/>
                    <path id="矢量 128121" d="M35.4007 27.0012C34.4721 27.0012 33.7148 27.7552 33.7148 28.687C33.7148 29.6187 34.4721 30.3728 35.4007 30.3728C36.3357 30.3728 37.0865 29.6188 37.0865 28.687C37.0864 27.7552 36.3357 27.0012 35.4007 27.0012Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128122" d="M52.2589 33.7444L48.8874 33.7444L48.8775 33.7444C48.8742 33.5452 48.8511 33.3411 48.7754 33.1435L42.0324 15.443C41.7854 14.7894 41.1565 14.3581 40.4585 14.3581L33.7155 14.3581C33.3072 14.3581 32.9121 14.5063 32.6059 14.7746L30.5909 16.5377L24.9409 9.12136C24.5194 8.56656 23.7885 8.32952 23.13 8.52538L9.64386 12.4599C9.02486 12.641 8.56063 13.158 8.45195 13.7934L5.08043 33.4596C5.06394 33.5567 5.0903 33.6489 5.0903 33.7444L5.05736 33.7444L1.68579 33.7444C0.757283 33.7444 0 34.4984 0 35.4302C0 36.362 0.757283 37.116 1.68579 37.116L4.3824 37.116L8.42893 46.1045C8.42893 46.7268 9.18621 47.2306 10.1147 47.2306L10.4242 47.2306C10.2366 47.7591 10.1147 48.3221 10.1147 48.9164C10.1147 51.7118 12.38 53.9737 15.172 53.9737C17.9707 53.9737 20.2293 51.7118 20.2293 48.9164C20.2293 48.3221 20.1075 47.7591 19.9198 47.2306L34.025 47.2306C33.8373 47.7591 33.7155 48.3221 33.7155 48.9164C33.7155 51.7118 35.9808 53.9737 38.7729 53.9737C41.5715 53.9737 43.8302 51.7118 43.8302 48.9164C43.8302 48.3221 43.7083 47.7591 43.5207 47.2306L43.8302 47.2306C44.7653 47.2306 45.516 46.7268 45.516 46.1045L49.5625 37.116L52.2591 37.116C53.1942 37.116 53.9449 36.362 53.9449 35.4302C53.9449 34.4984 53.194 33.7444 52.2589 33.7444ZM11.5996 15.4017L22.9622 12.0862L29.0039 20.0162C29.2871 20.3866 29.7118 20.6237 30.1761 20.6714C30.6304 20.701 31.1012 20.5693 31.4535 20.2632L34.3476 17.7296L39.2963 17.7296L45.3974 33.7444L8.45529 33.7444L11.5996 15.4017ZM16.8578 48.9163C16.8578 49.8464 16.1005 50.6021 15.172 50.6021C14.2435 50.6021 13.4862 49.8464 13.4862 48.9163C13.4862 47.9861 14.2435 47.2305 15.172 47.2305C16.1005 47.2305 16.8578 47.9861 16.8578 48.9163ZM40.4585 48.9163C40.4585 49.8464 39.7013 50.6021 38.7728 50.6021C37.8443 50.6021 37.087 49.8464 37.087 48.9163C37.087 47.9861 37.8443 47.2305 38.7728 47.2305C39.7013 47.2305 40.4585 47.9861 40.4585 48.9163ZM42.8292 43.859L11.1156 43.859L8.07991 37.1159L45.8649 37.1159L42.8292 43.859Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128123" d="M21.4211 22.4377C20.7626 21.7792 19.6958 21.7792 19.0373 22.4377L15.6658 25.8093C15.0072 26.4678 15.0072 27.5345 15.6658 28.193C16.3242 28.8516 17.391 28.8516 18.0495 28.193L20.2292 26.0134L22.4089 28.193C22.7381 28.5223 23.1694 28.687 23.6007 28.687C24.0321 28.687 24.4634 28.5223 24.7926 28.193C25.4511 27.5346 25.4511 26.4678 24.7926 25.8093L21.4211 22.4377Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  // 冶炼
                  routerPath: '/Smelting_Industry',
                },
                {
                  name: this.$t('message.header.industryName15'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 54" width="54.000000" height="54.000000" fill="none">
                    <rect id="事业快车改 1" width="54.000000" height="53.999996" x="0.000000" y="0.000000"/>
                    <path id="矢量 128135" d="M51.2004 25.725L38.5854 12.2089L38.5735 12.1984C38.5591 12.1833 38.5442 12.1688 38.5287 12.1549L38.4931 12.1206C38.4787 12.1075 38.4628 12.0969 38.447 12.0851L38.4036 12.0521L38.3588 12.0232L38.3087 11.9929L38.26 11.9691L38.2099 11.9441L38.1572 11.9244C38.1408 11.9176 38.1241 11.9115 38.1072 11.9059C38.0887 11.8993 38.069 11.8954 38.0505 11.8901L37.9991 11.8769L37.9451 11.8677C37.9263 11.8641 37.9075 11.861 37.8885 11.8585L37.8384 11.8545C37.8169 11.8531 37.7954 11.8522 37.7739 11.8519L37.7567 11.8506L1.13821 11.8506C0.937344 11.8515 0.740261 11.9053 0.566803 12.0066C0.393346 12.1079 0.249634 12.2531 0.150135 12.4276C0.0506357 12.6021 -0.00114013 12.7998 1.90481e-05 13.0006L1.90481e-05 36.8843C-0.00053389 37.0576 0.0382157 37.2287 0.113353 37.3849C0.18849 37.541 0.298059 37.6781 0.433817 37.7858C0.569575 37.8935 0.727987 37.969 0.897138 38.0067C1.08157 38.1318 1.30157 38.1977 1.5242 38.1977L47.1851 38.1977C50.9501 38.1977 54.0116 35.1032 54.0116 31.3C54.013 30.2154 53.7593 29.1457 53.2709 28.1772C52.7826 27.2087 52.0733 26.3687 51.2004 25.725ZM40.4692 24.401L32.9932 24.401L32.9932 17.996L40.6325 17.996C40.7015 17.9959 40.7703 17.9893 40.838 17.9763L46.8346 24.401L40.4692 24.401L40.4692 24.401ZM47.1851 35.8963L2.27641 35.8963L2.27641 14.1481L37.268 14.1481L38.7131 15.6959L31.8537 15.6959C31.653 15.6971 31.4561 15.7511 31.2828 15.8524C31.1096 15.9538 30.9661 16.099 30.8667 16.2734C30.7673 16.4478 30.7156 16.6453 30.7168 16.846L30.7168 25.5498C30.7168 26.1847 31.2266 26.6998 31.8537 26.6998L47.1837 26.6998C48.0795 26.6985 48.9529 26.9659 49.6986 27.4665L49.717 27.4876C49.8158 27.593 49.9331 27.6786 50.0622 27.7379C50.5864 28.171 51.0083 28.7148 51.2975 29.3302C51.5868 29.9456 51.7362 30.6174 51.7352 31.2974C51.7352 33.8346 49.6933 35.8963 47.1837 35.8963L47.1851 35.8963Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128136" d="M14.6925 15.8022L6.16127 15.8022C5.96294 15.8025 5.76818 15.8549 5.59658 15.9544C5.42498 16.0538 5.2826 16.1967 5.18377 16.3686C5.08494 16.5406 5.03315 16.7355 5.03362 16.9339L5.03362 25.5006C5.03362 26.125 5.53816 26.6322 6.16127 26.6322L14.6925 26.6322C14.8909 26.632 15.0858 26.5794 15.2575 26.4799C15.4292 26.3803 15.5716 26.2372 15.6704 26.0651C15.7692 25.8929 15.8208 25.6978 15.8201 25.4993L15.8201 16.9352C15.8208 16.7367 15.7692 16.5415 15.6704 16.3694C15.5716 16.1972 15.4292 16.0542 15.2575 15.9546C15.0858 15.855 14.8909 15.8025 14.6925 15.8022ZM13.5661 24.369L7.28761 24.369L7.28761 18.0655L13.5661 18.0655L13.5661 24.369L13.5661 24.369ZM27.5722 15.8022L19.0397 15.8022C18.8416 15.8027 18.647 15.8553 18.4756 15.9548C18.3042 16.0543 18.162 16.1972 18.0633 16.369C17.9646 16.5409 17.9129 16.7357 17.9134 16.9339L17.9134 25.5006C17.9134 26.125 18.4179 26.6322 19.0397 26.6322L27.5722 26.6322C27.7706 26.6318 27.9653 26.5791 28.1368 26.4794C28.3082 26.3798 28.4505 26.2368 28.5491 26.0647C28.6477 25.8926 28.6993 25.6976 28.6986 25.4993L28.6986 16.9352C28.6995 16.7368 28.6481 16.5417 28.5495 16.3695C28.4509 16.1973 28.3086 16.0542 28.137 15.9546C27.9655 15.855 27.7706 15.8025 27.5722 15.8022ZM26.4446 24.369L20.1661 24.369L20.1661 18.0655L26.4446 18.0655L26.4446 24.369ZM46.2971 39.8875L1.12766 39.8875C0.929629 39.8877 0.735146 39.94 0.563726 40.0391C0.392306 40.1383 0.249981 40.2808 0.151034 40.4523C0.052087 40.6239 -1.97528e-07 40.8184 7.85373e-10 41.0164C7.85373e-10 41.6409 0.504547 42.148 1.12634 42.148L46.2985 42.148C46.4966 42.1476 46.6912 42.095 46.8626 41.9955C47.034 41.896 47.1762 41.7531 47.2749 41.5813C47.3736 41.4094 47.4253 41.2146 47.4248 41.0164C47.4253 40.8183 47.3736 40.6235 47.2749 40.4516C47.1762 40.2797 47.034 40.1369 46.8626 40.0374C46.6912 39.9379 46.4966 39.8853 46.2985 39.8848L46.2971 39.8875Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/High-speed_Train_Production_Industry',
                },
                {
                  name: this.$t('message.header.industryName16'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 54" width="54.000000" height="54.000000" fill="none">
                    <rect id="Icon - 医院 1" width="54.000000" height="53.999996" x="0.000000" y="0.000000"/>
                    <path id="矢量 128145" d="M27.3945 10.7314C27.9746 10.7314 28.4492 11.2061 28.4492 11.7861L28.4492 43.2686L12.1016 43.2686L12.1016 11.7861C12.1016 11.2061 12.5762 10.7314 13.1562 10.7314L27.3945 10.7314ZM27.3945 8.09473L13.1562 8.09473C11.1154 8.09473 9.46484 9.74531 9.46484 11.7861L9.46484 45.9053L31.0859 45.9053L31.0859 11.7861C31.0859 9.74531 29.4354 8.09473 27.3945 8.09473Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128146" d="M45.957 45.9053L8.04102 45.9053C7.31328 45.9053 6.72266 45.3146 6.72266 44.5869C6.72266 43.8592 7.31328 43.2686 8.04102 43.2686L45.957 43.2686C46.6848 43.2686 47.2754 43.8592 47.2754 44.5869C47.2754 45.3146 46.6848 45.9053 45.957 45.9053ZM17.5859 21.0674C16.8582 21.0674 16.2676 20.4768 16.2676 19.749L16.2676 17.5342C16.2676 16.8064 16.8582 16.2158 17.5859 16.2158C18.3137 16.2158 18.9043 16.8064 18.9043 17.5342L18.9043 19.749C18.9043 20.4768 18.3137 21.0674 17.5859 21.0674ZM22.9648 21.0674C22.2371 21.0674 21.6465 20.4768 21.6465 19.749L21.6465 17.5342C21.6465 16.8064 22.2371 16.2158 22.9648 16.2158C23.6926 16.2158 24.2832 16.8064 24.2832 17.5342L24.2832 19.749C24.2832 20.4768 23.6926 21.0674 22.9648 21.0674ZM17.5859 30.5068C16.8582 30.5068 16.2676 29.9162 16.2676 29.1885L16.2676 26.9736C16.2676 26.2459 16.8582 25.6553 17.5859 25.6553C18.3137 25.6553 18.9043 26.2459 18.9043 26.9736L18.9043 29.1885C18.9043 29.9162 18.3137 30.5068 17.5859 30.5068ZM22.9648 30.5068C22.2371 30.5068 21.6465 29.9162 21.6465 29.1885L21.6465 26.9736C21.6465 26.2459 22.2371 25.6553 22.9648 25.6553C23.6926 25.6553 24.2832 26.2459 24.2832 26.9736L24.2832 29.1885C24.2832 29.9162 23.6926 30.5068 22.9648 30.5068Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128147" d="M21.8848 38.1533L21.8848 43.2686L18.668 43.2686L18.668 38.1533L21.8848 38.1533ZM23.4879 35.5166L17.0596 35.5166C16.49 35.5166 16.0312 35.9807 16.0312 36.5449L16.0312 45.9053L24.5215 45.9053L24.5215 36.5449C24.5215 35.9807 24.0574 35.5166 23.4879 35.5166ZM34.9365 32.7744L29.9268 32.7744C29.199 32.7744 28.6084 32.1838 28.6084 31.4561C28.6084 30.7283 29.199 30.1377 29.9268 30.1377L34.9365 30.1377C35.6643 30.1377 36.2549 30.7283 36.2549 31.4561C36.2549 32.1838 35.6643 32.7744 34.9365 32.7744ZM34.9365 38.2061L29.9268 38.2061C29.199 38.2061 28.6084 37.6154 28.6084 36.8877C28.6084 36.16 29.199 35.5693 29.9268 35.5693L34.9365 35.5693C35.6643 35.5693 36.2549 36.16 36.2549 36.8877C36.2549 37.6154 35.6643 38.2061 34.9365 38.2061ZM43.2158 45.0088C42.4881 45.0088 41.8975 44.4182 41.8975 43.6904L41.8975 26.71C41.8975 25.9822 42.4881 25.3916 43.2158 25.3916C43.9436 25.3916 44.5342 25.9822 44.5342 26.71L44.5342 43.6904C44.5342 44.4182 43.9436 45.0088 43.2158 45.0088Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128148" d="M45.9578 28.3446C45.7944 28.3446 45.6309 28.3129 45.4727 28.2496L29.4414 21.9215C28.7664 21.6526 28.4342 20.8879 28.6979 20.2129C28.9668 19.5379 29.7315 19.2057 30.4065 19.4694L46.4377 25.7975C47.1127 26.0664 47.445 26.8311 47.1813 27.5061C46.9809 28.0282 46.4852 28.3446 45.9578 28.3446L45.9578 28.3446Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Medical_Service_Industry',
                },
              ],
            },
          ],
        },
        {
          id: 'about',
          name: this.$t('message.header.firstNav4'), // 关于我们
          routerPath: '',
          children: [
            {
              id: 'about',
              name: this.$t('message.header.firstNav4'), // 关于我们
              routerPath: '/About',
            },
            {
              id: 'contact',
              name: this.$t('message.footer.contactUs'),
              routerPath: '/Contact',
            },
            // {
            //   id: 'news',
            //   name: this.$t('message.header.news'), // 新闻动态
            //   routerPath: '/News',
            // },
          ],
        },
      ],
      navListMobile: [
        {
          id: 'products',
          name: this.$t('message.header.firstNav1'), // 产品
          routerPath: '',
          children: [
            {
              id: 'software',
              name: this.$t('message.header.secondProductNav1'),
              routerPath: '',
              pid: 'second-software',
              children: [
                {
                  name: this.$t('message.header.productLabel1'),
                  icon: require('@/assets/images/header/scene-icon1.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon1-active.svg'),
                  iconClass: 'w22',
                  desc: this.$t('message.header.productDesc1'),
                  routerPath: '/Wisdom_AI_Applications',
                },
                {
                  name: this.$t('message.header.productLabel2'),
                  icon: require('@/assets/images/header/product-icon2.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active2.svg'),
                  iconClass: 'w18',
                  desc: this.$t('message.header.productDesc2'),
                  routerPath: '/Wisdom_BI_Analysis',
                },
                {
                  name: this.$t('message.header.productLabel3'),
                  icon: require('@/assets/images/header/product-icon3.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active3.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc3'),
                  routerPath: '/Business_Manage_System',
                },
                {
                  name: this.$t('message.header.productLabel4'),
                  icon: require('@/assets/images/header/product-icon1.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active1.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc4'),
                  routerPath: '/Intelligent_Device_Management_Platform',
                },
              ],
            },
            {
              id: 'hardware',
              name: this.$t('message.header.secondProductNav2'),
              routerPath: '',
              pid: 'second-hardware',
              children: [
                {
                  name: this.$t('message.header.productLabel5'),
                  icon: require('@/assets/images/header/product-icon5.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active5.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc5'),
                  routerPath: '/Automation',
                },
                {
                  name: this.$t('message.header.productLabel6'),
                  icon: require('@/assets/images/header/product-icon6.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active6.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc6'),
                  routerPath: '/AI_Robot',
                },
                {
                  name: this.$t('message.header.productLabel18'),
                  icon: require('@/assets/images/header/product-icon18.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active18.svg'),
                  iconClass: 'w20',
                  desc: this.$t('message.header.productDesc18'),
                  routerPath: '/Follow_Robot',
                },
              ],
            },
            {
              id: 'iot',
              name: this.$t('message.header.secondProductNav3'),
              routerPath: '',
              pid: 'second-iot',
              children: [
                {
                  name: this.$t('message.header.productLabel7'),
                  icon: require('@/assets/images/header/product-icon7.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active7.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc7'),
                  routerPath: '/Wearable_Devices',
                },
                {
                  name: this.$t('message.header.productLabel8'),
                  icon: require('@/assets/images/header/product-icon8.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active8.svg'),
                  iconClass: 'w21',
                  desc: this.$t('message.header.productDesc8'),
                  routerPath: '/Self_Collect_Devices',
                },
                {
                  name: this.$t('message.header.productLabel9'),
                  icon: require('@/assets/images/header/product-icon9.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active9.svg'),
                  iconClass: 'w18',
                  desc: this.$t('message.header.productDesc9'),
                  routerPath: '/High_Precision_Positioning_Devices',
                },
                {
                  name: this.$t('message.header.productLabel10'),
                  icon: require('@/assets/images/header/product-icon10.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active10.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc10'),
                  routerPath: '/Display_Updated_Devices',
                },

                {
                  name: this.$t('message.header.productLabel11'),
                  icon: require('@/assets/images/header/product-icon11.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active11.svg'),
                  iconClass: 'w22',
                  desc: this.$t('message.header.productDesc11'),
                  routerPath: '/Quick_Inventory_Scanning_Devices',
                },
                {
                  name: this.$t('message.header.productLabel17'),
                  icon: require('@/assets/images/header/product-icon12.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active12.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc17'),
                  routerPath: '/Error_Proofing_Prompt_Devices',
                },
                // {
                //   name: this.$t('message.header.productLabel12'),
                //   icon: require('@/assets/images/header/product-icon12.svg'),
                //   activeIcon: require('@/assets/images/header/product-icon-active12.svg'),
                //   iconClass: 'w19',
                //   desc: this.$t('message.header.productDesc12'),
                //   routerPath: '/Lighting_Guidance_Devices',
                // },
                {
                  name: this.$t('message.header.productLabel13'),
                  icon: require('@/assets/images/header/product-icon13.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active13.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc13'),
                  routerPath: '/Unattended_Devices',
                },
                {
                  name: this.$t('message.header.productLabel14'),
                  icon: require('@/assets/images/header/product-icon14.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active14.svg'),
                  iconClass: 'w20',
                  desc: this.$t('message.header.productDesc14'),
                  routerPath: '/Tool_Circulation_Track_Devices',
                },

                {
                  name: this.$t('message.header.productLabel15'),
                  icon: require('@/assets/images/header/product-icon15.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active15.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc15'),
                  routerPath: '/Quick_Call_Devices',
                },
                {
                  name: this.$t('message.header.productLabel16'),
                  icon: require('@/assets/images/header/product-icon16.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active16.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc16'),
                  routerPath: '/Information_Perception_Devices',
                },
                {
                  name: this.$t('message.header.productLabel19'),
                  icon: require('@/assets/images/header/product-icon19.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active19.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc19'),
                  routerPath: '/Safety_Protection_Devices',
                },
                {
                  name: this.$t('message.header.productLabel20'),
                  icon: require('@/assets/images/header/product-icon20.svg'),
                  activeIcon: require('@/assets/images/header/product-icon-active20.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.productDesc20'),
                  routerPath: '/Baggage_Identification_Devices',
                },
              ],
            },
          ],
        },
        {
          id: 'scenes',
          name: this.$t('message.header.firstNav2'), // 场景
          routerPath: '',
          children: [
            {
              id: 'second-scenes',
              routerPath: '',
              pid: 'second-scenes',
              children: [
                {
                  name: this.$t('message.header.sceneLabel1'),
                  icon: require('@/assets/images/header/scene-icon1.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon1-active.svg'),
                  iconClass: 'w22',
                  desc: this.$t('message.header.sceneDesc1'),
                  routerPath: '/Supply_Chain_Manage',
                  withBottomArrow: true,
                  detailUrl: require('@/assets/images/header/detail1.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel2'),
                  icon: require('@/assets/images/header/scene-icon2.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon2-active.svg'),
                  iconClass: 'w21',
                  desc: this.$t('message.header.sceneDesc2'),
                  routerPath: '/Material_External_Warehouse_Manage',
                  withBottomArrow: true,
                  detailUrl: require('@/assets/images/header/detail2.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel3'),
                  icon: require('@/assets/images/header/scene-icon3.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon3-active.svg'),
                  iconClass: 'w18',
                  desc: this.$t('message.header.sceneDesc3'),
                  routerPath: '/Park_Manage',
                  withBottomArrow: true,
                  detailUrl: require('@/assets/images/header/detail3.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel4'),
                  icon: require('@/assets/images/header/scene-icon4.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon4-active.svg'),
                  iconClass: 'w20',
                  desc: this.$t('message.header.sceneDesc4'),
                  routerPath: '/Platform_Manage',
                  withBottomArrow: true,
                  detailUrl: require('@/assets/images/header/detail4.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel5'),
                  icon: require('@/assets/images/header/scene-icon5.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon5-active.svg'),
                  iconClass: 'w15',
                  desc: this.$t('message.header.sceneDesc5'),
                  routerPath: '/Loading_and_Unloading_Vehicle_Storage',
                  withBottomArrow: false,
                  detailUrl: require('@/assets/images/header/detail5.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel6'),
                  icon: require('@/assets/images/header/scene-icon6.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon6-active.svg'),
                  iconClass: 'w16',
                  desc: this.$t('message.header.sceneDesc6'),
                  routerPath: '/Delivery_Transport',
                  detailUrl: require('@/assets/images/header/detail6.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel7'),
                  icon: require('@/assets/images/header/scene-icon7.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon7-active.svg'),
                  iconClass: 'w20',
                  desc: this.$t('message.header.sceneDesc7'),
                  routerPath: '/Finished_Product_External_Warehouse_Manage',
                  detailUrl: require('@/assets/images/header/detail7.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel8'),
                  icon: require('@/assets/images/header/scene-icon8.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon8-active.svg'),
                  iconClass: 'w18',
                  desc: this.$t('message.header.sceneDesc8'),
                  routerPath: '/Production_Process_Data_Manage',
                  withTopArrow: true,
                  detailUrl: require('@/assets/images/header/detail8.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel9'),
                  icon: require('@/assets/images/header/scene-icon9.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon9-active.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.sceneDesc9'),
                  routerPath: '/Order_Picking',
                  withTopArrow: true,
                  detailUrl: require('@/assets/images/header/detail9.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel10'),
                  icon: require('@/assets/images/header/scene-icon10.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon10-active.svg'),
                  iconClass: 'w18',
                  desc: this.$t('message.header.sceneDesc10'),
                  routerPath: '/Finished_Product_Storage_and_Tallying',
                  withTopArrow: true,
                  detailUrl: require('@/assets/images/header/detail10.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel11'),
                  icon: require('@/assets/images/header/scene-icon11.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon11-active.svg'),
                  iconClass: 'w18',
                  desc: this.$t('message.header.sceneDesc11'),
                  routerPath: '/Operational_Standard_Manage',
                  detailUrl: require('@/assets/images/header/detail11.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel12'),
                  icon: require('@/assets/images/header/scene-icon12.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon12-active.svg'),
                  iconClass: 'w18',
                  desc: this.$t('message.header.sceneDesc12'),
                  routerPath: '/Device_Inspection_Maintenance_Manage',
                  detailUrl: require('@/assets/images/header/detail12.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel13'),
                  icon: require('@/assets/images/header/scene-icon13.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon13-active.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.sceneDesc13'),
                  routerPath: '/Property_Manage',
                  detailUrl: require('@/assets/images/header/detail13.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel14'),
                  icon: require('@/assets/images/header/scene-icon14.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon14-active.svg'),
                  iconClass: 'w18',
                  desc: this.$t('message.header.sceneDesc14'),
                  routerPath: '/Staff_Manage',
                  detailUrl: require('@/assets/images/header/detail14.png'),
                },
                {
                  name: this.$t('message.header.sceneLabel15'),
                  icon: require('@/assets/images/header/scene-icon15.svg'),
                  activeIcon: require('@/assets/images/header/scene-icon15-active.svg'),
                  iconClass: 'w19',
                  desc: this.$t('message.header.sceneDesc15'),
                  routerPath: '/Vehicle_Manage',
                  detailUrl: require('@/assets/images/header/detail15.png'),
                },
              ],
            },
          ],
        },
        {
          id: 'industrys',
          name: this.$t('message.header.firstNav3'), // 行业解决方案
          routerPath: '',
          children: [
            {
              id: 'industry1',
              routerPath: '',
              pid: 'second-industry1',
              name: this.$t('message.header.industryTitle'),
              children: [
                {
                  name: this.$t('message.header.industryName1'),
                  icon: `<svg
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 54 54"
                    width="54.000000"
                    height="54.000000"
                    fill="none"
                  >
                    <rect id="汽车 1" width="54.000000" height="54.000000" x="0.000000" y="0.000000" />
                    <path
                      id="矢量 128099"
                      d="M48.1376 24.6324L46.9631 24.6324L46.6138 23.4478L49.8268 23.4478C50.1832 23.4478 50.5304 23.335 50.8187 23.1255C51.107 22.9161 51.3216 22.6207 51.4317 22.2818C51.5418 21.9429 51.5418 21.5778 51.4317 21.2388C51.3216 20.8999 51.107 20.6046 50.8187 20.3951C50.5304 20.1856 50.1832 20.0728 49.8268 20.0728L45.6182 20.0728L43.7417 13.716C42.9874 11.6691 40.6856 10.125 38.3906 10.125L15.957 10.125C13.662 10.125 11.3619 11.6691 10.5722 13.8223L8.72944 20.0728L5.0625 20.0728C4.70613 20.0728 4.35892 20.1856 4.07061 20.3951C3.78231 20.6046 3.56772 20.8999 3.45759 21.2388C3.34747 21.5778 3.34747 21.9429 3.45759 22.2818C3.56772 22.6207 3.78231 22.9161 4.07061 23.1255C4.35892 23.335 4.70613 23.4478 5.0625 23.4478L7.73212 23.4478L7.38281 24.6324L6.75 24.6324C4.88869 24.6324 3.375 26.1461 3.375 28.0074L3.375 42.9283L6.06994 42.9283L6.06994 44.7643C6.06994 45.1207 6.18276 45.4679 6.39222 45.7562C6.60169 46.0445 6.89705 46.2591 7.23597 46.3692C7.57489 46.4793 7.93998 46.4793 8.2789 46.3692C8.61783 46.2591 8.91319 46.0445 9.12265 45.7562C9.33212 45.4679 9.44494 45.1207 9.44494 44.7643L9.44494 42.9283L45.8595 42.9283L45.8595 44.7643C45.8595 45.1207 45.9723 45.4679 46.1818 45.7562C46.3912 46.0445 46.6866 46.2591 47.0255 46.3692C47.3645 46.4793 47.7295 46.4793 48.0685 46.3692C48.4074 46.2591 48.7028 46.0445 48.9122 45.7562C49.1217 45.4679 49.2345 45.1207 49.2345 44.7643L49.2345 42.9283L51.5143 42.9283L51.5143 28.0074C51.5131 27.4152 51.3564 26.8336 51.0598 26.3209C50.7633 25.8082 50.3372 25.3824 49.8244 25.0861C49.3116 24.7897 48.7299 24.6333 48.1376 24.6324L48.1376 24.6324ZM6.75 39.5516L6.75 34.0166L10.6414 34.0166C12.0369 34.0166 13.3059 33.1374 13.7987 31.833L15.0677 28.4732C15.1251 28.3196 15.1318 28.1627 15.1436 28.0074L38.9019 28.0074C38.9137 28.1627 38.9205 28.3196 38.9779 28.4732L40.2469 31.8296C40.49 32.4708 40.922 33.0232 41.4858 33.4137C42.0495 33.8041 42.7184 34.0144 43.4042 34.0166L48.1376 34.0166L48.1376 39.5516L6.75 39.5516ZM48.1376 30.6416L43.4042 30.6399L42.4102 28.0057L48.1376 28.0057L48.1376 30.6416L48.1376 30.6416ZM11.5239 22.5146C11.6004 22.3556 11.6505 22.1852 11.6724 22.0101L13.7734 14.8837C14.0096 14.2425 15.0137 13.5 15.957 13.5L38.3906 13.5C39.3339 13.5 40.338 14.2425 40.5388 14.7757L43.4447 24.6307L10.9012 24.6307L11.5239 22.5146ZM11.637 28.0074L10.6414 30.6433L6.75 30.6433L6.75 28.0074L11.637 28.0074ZM32.4186 33.0244L22.4707 33.0244C22.1144 33.0244 21.7672 33.1372 21.4789 33.3467C21.1906 33.5561 20.976 33.8515 20.8658 34.1904C20.7557 34.5293 20.7557 34.8944 20.8658 35.2333C20.976 35.5723 21.1906 35.8676 21.4789 36.0771C21.7672 36.2866 22.1144 36.3994 22.4707 36.3994L32.4186 36.3994C32.7749 36.3994 33.1221 36.2866 33.4104 36.0771C33.6988 35.8676 33.9133 35.5723 34.0235 35.2333C34.1336 34.8944 34.1336 34.5293 34.0235 34.1904C33.9133 33.8515 33.6988 33.5561 33.4104 33.3467C33.1221 33.1372 32.7749 33.0244 32.4186 33.0244Z"
                      fill="rgb(255,255,255)"
                      fill-rule="nonzero"
                    />
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Vehicle_Industry',
                },
                {
                  name: this.$t('message.header.industryName2'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 54" width="54.000000" height="54.000000" fill="none">
                    <rect id="装备制造 1" width="54.000000" height="54.000000" x="0.000000" y="0.000000"/>
                    <path id="矢量 128104" d="M11.965 22.3708C10.7971 22.346 9.65624 22.0141 8.65726 21.4085C7.65828 20.8029 6.83637 19.9449 6.27418 18.9209C5.712 17.8969 5.42936 16.7428 5.45469 15.5749C5.42936 14.407 5.712 13.253 6.27418 12.2289C6.83637 11.2049 7.65828 10.3469 8.65726 9.74133C9.65624 9.13573 10.7971 8.80385 11.965 8.77905C13.133 8.80385 14.2738 9.13573 15.2728 9.74133C16.2717 10.3469 17.0937 11.2049 17.6558 12.2289C18.218 13.253 18.5007 14.407 18.4753 15.5749C18.5007 16.7428 18.218 17.8969 17.6558 18.9209C17.0937 19.9449 16.2717 20.8029 15.2728 21.4085C14.2738 22.0141 13.133 22.346 11.965 22.3708ZM11.965 11.6345C11.2982 11.6591 10.6497 11.8589 10.0847 12.2139C9.51971 12.5688 9.05821 13.0664 8.74667 13.6564C8.43514 14.2465 8.28456 14.9082 8.31009 15.5749C8.28456 16.2417 8.43514 16.9034 8.74667 17.4934C9.05821 18.0835 9.51971 18.581 10.0847 18.936C10.6497 19.2909 11.2982 19.4908 11.965 19.5154C12.6318 19.4908 13.2803 19.2909 13.8453 18.936C14.4103 18.581 14.8718 18.0835 15.1833 17.4934C15.4949 16.9034 15.6455 16.2417 15.6199 15.5749C15.6455 14.9082 15.4949 14.2465 15.1833 13.6564C14.8718 13.0664 14.4103 12.5688 13.8453 12.2139C13.2803 11.8589 12.6318 11.6591 11.965 11.6345L11.965 11.6345Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128105" d="M17.1324 26.5683L6.7102 26.5683C6.44909 26.5728 6.19212 26.5026 5.96954 26.3661C5.74696 26.2295 5.56803 26.0321 5.45382 25.7973L0.171324 16.2603C0.058839 16.0493 0 15.814 0 15.575C0 15.3359 0.0588389 15.1006 0.171324 14.8897L5.45382 5.26695C5.57465 5.03958 5.75588 4.84996 5.97755 4.71897C6.19923 4.58798 6.45274 4.5207 6.7102 4.52454L17.1324 4.52454C17.3857 4.52276 17.6345 4.59119 17.8512 4.72224C18.068 4.85329 18.2442 5.04183 18.3602 5.26695L23.757 14.8897C23.8694 15.1006 23.9283 15.3359 23.9283 15.575C23.9283 15.814 23.8694 16.0493 23.757 16.2603L18.4745 25.883C18.3451 26.1184 18.148 26.3096 17.9087 26.4317C17.6694 26.5539 17.399 26.6015 17.1324 26.5683ZM7.53827 23.7129L16.39 23.7129L20.873 15.575L16.39 7.37994L7.53826 7.37994L3.05528 15.575L7.53827 23.7129ZM49.2843 24.9121C49.0204 24.9061 48.7635 24.827 48.5419 24.6837L28.554 12.4626C28.3445 12.3365 28.1708 12.1587 28.0497 11.9462C27.9286 11.7337 27.8641 11.4936 27.8624 11.2491C27.8607 11.0045 27.9219 10.7636 28.0401 10.5494L31.4094 4.46743C31.4796 4.30176 31.5811 4.15118 31.7084 4.02395C31.8356 3.89672 31.9862 3.79523 32.1518 3.72503C32.3373 3.67064 32.5319 3.65524 32.7236 3.67982C32.9153 3.70439 33.0998 3.76839 33.2654 3.8678L53.2533 16.1175C53.4628 16.2436 53.6365 16.4214 53.7576 16.6339C53.8787 16.8464 53.9432 17.0864 53.9449 17.331C53.9466 17.5756 53.8854 17.8165 53.7672 18.0306L50.5406 24.1697C50.4482 24.3387 50.3219 24.4868 50.1696 24.6048C50.0173 24.7227 49.8422 24.8079 49.6555 24.855L49.2843 24.9121ZM31.0953 10.6351L48.7417 21.4L50.712 18.002L33.0656 7.15151L31.0953 10.6351Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128106" d="M35.7216 37.9898L35.3504 37.9898L22.8438 34.5918C22.6306 34.5346 22.4328 34.4306 22.2649 34.2874C22.0969 34.1441 21.963 33.9653 21.8729 33.7638C21.775 33.5688 21.724 33.3537 21.724 33.1356C21.724 32.9174 21.775 32.7023 21.8729 32.5074L32.3237 13.9758C32.4161 13.8068 32.5425 13.6587 32.6948 13.5408C32.8471 13.4229 33.0221 13.3377 33.2089 13.2905C33.3953 13.2326 33.5925 13.2179 33.7855 13.2476C33.9784 13.2773 34.1621 13.3506 34.3225 13.4618L45.1159 19.9722C45.3292 20.0948 45.5063 20.2714 45.6295 20.4843C45.7527 20.6972 45.8176 20.9388 45.8177 21.1847C45.8178 21.4307 45.753 21.6723 45.6299 21.8853L37.0637 37.1617C36.946 37.4163 36.756 37.6306 36.5174 37.7778C36.2787 37.9251 36.0019 37.9988 35.7216 37.9898L35.7216 37.9898ZM25.3851 32.2789L35.0078 34.7917L42.4604 21.6854L34.2654 16.6599L25.3851 32.2789ZM28.1263 50.3251C27.9172 50.3319 27.7102 50.2826 27.5266 50.1823L16.8189 45.1568C16.595 45.0395 16.4049 44.8669 16.2663 44.6556C16.1278 44.4442 16.0455 44.2009 16.0273 43.9489C16.0091 43.6968 16.0555 43.4443 16.1621 43.2151L19.1889 37.1046C19.2892 36.9103 19.4319 36.7411 19.6065 36.6096C19.7812 36.478 19.9832 36.3875 20.1975 36.3446C20.4119 36.3018 20.6332 36.3078 20.845 36.3622L33.266 39.7601C33.4796 39.8182 33.6764 39.9261 33.8402 40.075C34.0041 40.2239 34.1302 40.4096 34.2083 40.6167C34.3066 40.8166 34.3577 41.0364 34.3577 41.2592C34.3577 41.4819 34.3066 41.7017 34.2083 41.9017L29.4683 49.6398C29.3333 49.8702 29.1352 50.0571 28.8974 50.1786C28.6596 50.3 28.392 50.3508 28.1263 50.3251ZM19.3602 43.1866L27.5837 47.0699L30.6676 42.0159L21.2447 39.446L19.3602 43.1866Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Manufacturing_Industry',
                },
                {
                  name: this.$t('message.header.industryName3'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 54" width="54.000000" height="54.000000" fill="none">
                    <rect id="255Phone手机 1" width="54.000000" height="53.999996" x="0.000000" y="0.000000"/>
                    <path id="矢量 128115" d="M37.125 6.75L37.125 47.25L16.875 47.25L16.875 6.75L37.125 6.75ZM37.125 3.375L16.875 3.375C15.0187 3.375 13.5 4.89375 13.5 6.75L13.5 47.25C13.5 49.1063 15.0187 50.625 16.875 50.625L37.125 50.625C38.9812 50.625 40.5 49.1063 40.5 47.25L40.5 6.75C40.5 4.89375 38.9812 3.375 37.125 3.375ZM14.3438 10.125L14.3438 13.5L39.6562 13.5L39.6562 10.125L14.3438 10.125ZM14.3438 40.5L39.6562 40.5L39.6562 37.125L14.3438 37.125L14.3438 40.5ZM23.625 45.5625L30.375 45.5625L30.375 42.1875L23.625 42.1875L23.625 45.5625Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Electrical_Industry',
                },
                {
                  name: this.$t('message.header.industryName4'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 54" width="54.000000" height="54.000000" fill="none">
                    <rect id="机场贵宾厅 1" width="54.000000" height="54.000000" x="0.000000" y="0.000000"/>
                    <path id="矢量 128134" d="M18.6787 54.0001L18.5902 54.0001C18.059 54.0001 17.6164 53.7345 17.3508 53.2919L10.623 44.7935L0.708197 36.6493C0.265574 36.3837 0 35.9411 0 35.4099C0 34.8788 0.177049 34.4362 0.531148 34.0821L4.78033 29.6558C5.22295 29.2132 5.84262 29.0362 6.4623 29.1247L13.0131 30.6296L19.918 23.9017L2.92131 14.6952C2.47869 14.4296 2.12459 13.987 2.03607 13.4558C1.94754 12.9247 2.12459 12.3935 2.47869 11.9509L8.14426 5.84272C8.58689 5.4001 9.20656 5.22305 9.82623 5.31157L32.9311 10.623C36.6492 6.55092 45.4131 -2.56712 51.4328 2.30174C52.6721 3.36403 53.3803 4.6919 53.3803 6.28534C53.4688 9.91485 50.1934 14.6952 43.1115 21.246L48.6885 45.1476C48.8656 45.8558 48.6 46.4755 48.0689 46.9181L42.2262 51.6099C41.7836 51.964 41.2525 52.0526 40.8098 51.964C40.2787 51.8755 39.8361 51.5214 39.5705 51.0788L30.4525 34.7017L23.8131 41.3411L25.318 47.0067C25.4951 47.6263 25.318 48.3345 24.8754 48.7771L19.918 53.5575C19.5639 53.8231 19.1213 54.0001 18.6787 54.0001L18.6787 54.0001ZM4.3377 35.1444L12.9246 42.2263L13.1902 42.4919L18.8557 49.5739L21.6 46.9181L20.0951 41.2526C19.918 40.6329 20.0951 40.0132 20.5377 39.5706L29.5672 30.5411C29.9213 30.187 30.541 29.9214 31.0721 30.0099C31.6033 30.0985 32.1344 30.4526 32.4 30.8952L41.7836 47.5378L45.1475 44.8821L39.5705 20.9804C39.3934 20.3607 39.659 19.7411 40.1016 19.2985C48.6885 11.4198 49.9279 7.79025 49.8393 6.37386C49.8393 5.84271 49.6623 5.40009 49.1311 5.04599C46.741 3.09846 41.6066 6.19682 34.8787 13.7214C34.4361 14.164 33.8164 14.4296 33.1967 14.2526L10.0918 8.94108L6.63934 12.5706L23.7246 21.9542C24.2557 22.2198 24.5213 22.7509 24.6098 23.2821C24.6984 23.8132 24.5213 24.4329 24.0787 24.787L14.6951 33.905C14.2525 34.3476 13.6328 34.5247 13.1016 34.3476L6.55082 32.8427L4.3377 35.1444L4.3377 35.1444Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Spaceflight_Industry',
                },
                {
                  name: this.$t('message.header.industryName5'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 48 48" width="48.000000" height="48.000000" fill="none">
                    <rect id="设备保养管理-线性图标 1" width="48.000000" height="48.000000" x="0.000000" y="0.000000"/>
                    <path id="矢量 128100" d="M25.1996 7.10761C24.7381 6.27684 24.1843 5.44607 24.1843 5.44607C24.092 5.35376 24.092 5.35376 23.9996 5.35376C23.9073 5.35376 23.815 5.35376 23.815 5.44607C23.815 5.44607 23.2612 6.18453 22.7996 7.10761C22.1535 8.30761 21.7843 9.13838 21.7843 9.69222C21.7843 10.9845 22.7996 11.9999 24.092 11.9999C25.3843 11.9999 26.3996 10.9845 26.3996 9.69222C26.3073 9.13838 25.9381 8.30761 25.1996 7.10761ZM23.9996 11.0768C23.815 11.0768 23.7227 10.9845 23.7227 10.7999C23.7227 10.6153 23.815 10.523 23.9996 10.523C24.4612 10.523 24.8304 10.1538 24.8304 9.69222C24.8304 9.50761 24.9227 9.4153 25.1073 9.4153C25.292 9.4153 25.3843 9.50761 25.3843 9.69222C25.3843 10.4307 24.7381 11.0768 23.9997 11.0768L23.9996 11.0768ZM32.7689 19.9384C32.5843 19.7538 32.3073 19.6615 32.1227 19.6615C31.5689 19.6615 31.015 19.3845 30.7381 18.8307C30.4612 18.3691 30.4612 17.723 30.7381 17.2615C30.8304 17.0768 30.9227 16.7999 30.8304 16.523C30.7381 16.2461 30.6458 16.0615 30.3689 15.9691L26.8612 13.9384C26.6766 13.8461 26.3997 13.8461 26.215 13.8461C25.9381 13.9384 25.7535 14.0307 25.6612 14.3076C25.3843 14.7691 24.8304 15.1384 24.2766 15.1384C23.7227 15.1384 23.0766 14.7691 22.892 14.3999C22.7997 14.2153 22.5227 14.0307 22.3381 13.9384C22.0612 13.8461 21.8766 13.9384 21.5997 14.0307L18.092 16.0615C17.9073 16.1538 17.7227 16.4307 17.6304 16.6153C17.5381 16.8922 17.6304 17.0768 17.7227 17.3538C17.9073 17.723 17.9997 18.0922 17.9073 18.5538C17.815 19.0153 17.5381 19.2922 17.1689 19.5691C16.892 19.7538 16.615 19.7538 16.3381 19.7538C16.0612 19.7538 15.8766 19.8461 15.692 20.0307C15.5073 20.2153 15.415 20.4922 15.415 20.6768L15.415 24.7384C15.415 25.0153 15.5073 25.1999 15.692 25.3845C15.8766 25.5691 16.1535 25.6615 16.3381 25.6615C17.2612 25.6615 17.9073 26.3999 17.9073 27.2307C17.9073 27.5076 17.815 27.7845 17.7227 28.0615C17.6304 28.2461 17.5381 28.523 17.6304 28.7999C17.7227 29.0768 17.815 29.2615 18.092 29.3538L21.5997 31.3845C21.7843 31.4768 22.0612 31.5691 22.3381 31.4768C22.615 31.3845 22.7997 31.2922 22.892 31.0153C23.0766 30.6461 23.4458 30.3691 23.9073 30.2768C24.2766 30.1845 24.7381 30.1845 25.1073 30.4615C25.3843 30.5538 25.5689 30.8307 25.6612 31.0153C25.8458 31.2922 26.1227 31.4768 26.492 31.4768C26.6766 31.4768 26.8612 31.3845 26.9535 31.3845L30.4612 29.3538C30.6458 29.2615 30.8304 28.9845 30.9227 28.7999C31.015 28.523 30.9227 28.3384 30.8304 28.0615C30.6458 27.6922 30.5535 27.2307 30.6458 26.8615C30.7381 26.4922 31.015 26.123 31.3843 25.8461C31.6612 25.6615 31.9381 25.6615 32.215 25.6615C32.492 25.6615 32.6766 25.5691 32.8612 25.3845C33.0458 25.1999 33.1381 24.923 33.1381 24.7384L33.1381 20.6768C33.0458 20.3999 32.9535 20.123 32.7689 19.9384ZM28.7073 28.0615L26.6766 29.2615C26.492 29.0768 26.215 28.8922 26.0304 28.7076C25.4766 28.4307 24.9227 28.2461 24.2766 28.2461C23.9996 28.2461 23.6304 28.2461 23.3535 28.3384C22.7996 28.523 22.2458 28.7999 21.7843 29.1691L19.7535 27.9691C19.8458 27.6922 19.8458 27.4153 19.8458 27.1384C19.8458 25.5691 18.7381 24.1845 17.2612 23.723L17.2612 21.323C17.5381 21.2307 17.815 21.1384 18.092 20.9538C18.9227 20.4922 19.4766 19.7538 19.7535 18.8307C19.9381 18.2768 19.9381 17.6307 19.7535 17.0768L21.8766 15.8768C22.5227 16.523 23.4458 16.8922 24.2766 16.8922C25.1996 16.8922 26.0304 16.523 26.6766 15.8768L28.7073 17.0768C28.5227 17.9999 28.615 18.923 29.0766 19.6615C29.5381 20.3999 30.2766 21.0461 31.1996 21.323L31.1996 23.723C30.9227 23.8153 30.6458 23.9076 30.3689 24.0922C29.0766 25.0153 28.3381 26.5845 28.7073 28.0615L28.7073 28.0615Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128101" d="M24.1849 19.2C22.2465 19.2 20.7695 20.7692 20.7695 22.6153C20.7695 24.5538 22.3388 26.0307 24.1849 26.0307C26.0311 26.0307 27.6003 24.4615 27.6003 22.6153C27.6926 20.7692 26.1234 19.2 24.1849 19.2L24.1849 19.2ZM25.7541 22.7076C25.7541 23.5384 25.0157 24.2769 24.1849 24.2769C23.3541 24.2769 22.6157 23.5384 22.6157 22.7076C22.6157 21.8769 23.3541 21.1384 24.1849 21.1384C25.108 21.1384 25.7541 21.7846 25.7541 22.7076Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128102" d="M10.6154 25.2923L10.6154 12.923L19.3846 12.923C19.5692 12.923 19.8462 12.7384 19.8462 12.4615L19.8462 11.5384C19.8462 11.3538 19.6615 11.0769 19.3846 11.0769L10.6154 11.0769L10.6154 8.49226L19.4769 8.49226C19.6615 8.49226 19.8462 8.30764 19.8462 8.12303L19.8462 7.19995C19.8462 7.01533 19.6615 6.83072 19.4769 6.83072L10.6154 6.83072L10.6154 4.33841C10.6154 3.23072 9.69231 2.30764 8.58462 2.30764L5.63077 2.30764C4.52308 2.30764 3.6 3.23072 3.6 4.33841L3.6 27.9692C2.58462 28.1538 1.84615 29.0769 1.84615 30.0923L1.84615 33.2307C0.738462 33.5076 0 34.3384 0 35.3538L0 43.5692C0 44.123 0.184615 44.6769 0.646154 45.0461C0.923077 45.4153 1.38462 45.6 1.84615 45.6923L45.7846 45.6923C46.9846 45.6923 47.9077 44.7692 47.9077 43.5692L47.9077 35.3538C47.9077 34.3384 47.1692 33.4153 46.1539 33.323L46.1539 30.1846C46.1539 29.0769 45.4154 28.2461 44.4 28.0615L44.4 4.33841C44.4 3.78456 44.2154 3.23072 43.7539 2.86149C43.3846 2.49226 42.8308 2.21533 42.2769 2.21533L39.3231 2.21533C38.2154 2.21533 37.2923 3.13841 37.2923 4.2461L37.2923 6.6461L28.4308 6.6461C28.2462 6.6461 28.0615 6.83072 28.0615 7.01533L28.0615 7.93841C28.0615 8.12303 28.2462 8.30764 28.4308 8.30764L37.2923 8.30764L37.2923 10.9846L28.4308 10.9846C28.2462 10.9846 28.0615 11.1692 28.0615 11.3538L28.0615 12.2769C28.0615 12.4615 28.2462 12.6461 28.4308 12.6461L37.2923 12.6461L37.2923 27.6923C37.2923 28.8 38.2154 29.723 39.3231 29.723L43.9385 29.723C44.2154 29.723 44.4 29.9076 44.4 30.1846L44.4 33.323L3.50769 33.323L3.50769 30.1846C3.50769 29.9076 3.69231 29.723 3.96923 29.723L8.58462 29.723C9.69231 29.723 10.6154 28.7999 10.6154 27.6923L10.6154 25.2923ZM42.2769 27.9692L39.6 27.9692C39.4154 27.9692 39.2308 27.7846 39.2308 27.5999L39.2308 4.33841C39.2308 4.15379 39.3231 4.06149 39.5077 4.06149L42.4615 4.06149C42.5539 4.06149 42.6462 4.06149 42.6462 4.15379C42.7385 4.2461 42.7385 4.2461 42.7385 4.33841L42.7385 27.5076C42.7385 27.7846 42.5539 27.9692 42.2769 27.9692ZM5.35385 4.33841C5.35385 4.15379 5.44615 4.06149 5.63077 4.06149L8.58462 4.06149C8.76923 4.06149 8.86154 4.15379 8.86154 4.33841L8.86154 27.5076C8.86154 27.6923 8.67692 27.8769 8.49231 27.8769L5.81539 27.8769C5.53846 27.8769 5.26154 27.6 5.26154 27.323L5.26154 4.33841L5.35385 4.33841ZM46.2462 43.5692C46.2462 43.7538 46.0615 43.9384 45.8769 43.9384L2.12308 43.9384C1.93846 43.9384 1.75385 43.7538 1.75385 43.5692L1.75385 35.3538C1.75385 35.1692 1.93846 34.9846 2.12308 34.9846L45.8769 34.9846C46.0615 34.9846 46.2462 35.1692 46.2462 35.3538L46.2462 43.5692L46.2462 43.5692Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Auto_Parts_Industry',
                },
                {
                  name: this.$t('message.header.industryName6'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 62" width="54.000000" height="62.000000" fill="none">
                    <rect id="医疗服务 1" width="54.000000" height="62.000000" x="0.000000" y="0.000000"/>
                    <path id="矢量 128110" d="M36.5625 8.39575L36.5625 17.4374L46.6875 17.4374L46.6875 53.6041L7.3125 53.6041L7.3125 17.4374L17.4375 17.4374L17.4375 8.39575L36.5625 8.39575L36.5625 8.39575ZM43.3125 21.3124L10.6875 21.3124L10.6875 49.7291L43.3125 49.7291L43.3125 21.3124L43.3125 21.3124ZM28.6796 26.47L28.6796 33.5833L34.875 33.5833L34.875 37.4583L28.6796 37.4583L28.6796 44.5715L25.3046 44.5715L25.3046 37.4583L19.1093 37.4583L19.1093 33.5833L25.3046 33.5833L25.3046 26.47L28.6796 26.47ZM33.1875 12.2708L20.8125 12.2708L20.8125 17.4374L33.1875 17.4374L33.1875 12.2708L33.1875 12.2708Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  // 生物医疗
                  routerPath: '/Biomedical_Industry',
                },
                {
                  name: this.$t('message.header.industryName7'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 54" width="54.000000" height="54.000000" fill="none">
                    <rect id="电商-壹米滴答 1" width="54.000000" height="54.000000" x="0.000000" y="0.000000"/>
                    <path id="矢量 128116" d="M45.818 47.4546L9.818 47.4546C9.3271 47.4546 8.99982 47.2909 8.67255 46.9637C8.34528 46.6364 8.18164 46.1455 8.18164 45.6546L10.6362 12.9273C10.6362 12.1091 11.4544 11.4546 12.2726 11.4546L43.3635 11.4546C44.1816 11.4546 44.9998 12.1091 44.9998 12.9273L47.4544 45.6546C47.4544 46.1455 47.2907 46.6364 46.9635 46.9637C46.6362 47.2909 46.3089 47.4546 45.818 47.4546ZM11.618 44.1819L44.018 44.1819L41.8907 14.7273L13.7453 14.7273L11.618 44.1819Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128117" d="M28.1458 28.1456C23.4004 28.1456 19.6367 24.2184 19.6367 19.6365C19.6367 19.1456 19.964 18.8184 20.4549 18.8184C20.9458 18.8184 21.2731 19.1456 21.2731 19.6365C21.2731 23.4002 24.3822 26.5093 28.1458 26.5093C31.9094 26.5093 35.0185 23.4002 35.0185 19.6365C35.0185 19.1456 35.3458 18.8184 35.8367 18.8184C36.3276 18.8184 36.6549 19.1456 36.6549 19.6365C36.8185 24.382 32.8913 28.1456 28.1458 28.1456Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128118" d="M27.818 14.7273C26.8362 14.7273 26.1816 14.0727 26.1816 13.0909L26.1816 10.6364C26.1816 9.65455 26.8362 9 27.818 9C28.7998 9 29.4544 9.65455 29.4544 10.6364L29.4544 13.0909C29.4544 14.0727 28.7998 14.7273 27.818 14.7273L27.818 14.7273Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  class: 'special',
                  routerPath: '/Logistics_Industry',
                },
                {
                  name: this.$t('message.header.industryName8'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 46 46" width="46.000000" height="46.000000" fill="none">
                    <rect id="地铁 1" width="46.000000" height="46.000000" x="0.000000" y="0.000000"/>
                    <path id="矢量 128131" d="M37.0206 0C39.6624 0 41.8046 2.13102 41.8046 4.75865L41.8046 34.3676C41.803 35.1349 41.6161 35.8905 41.2599 36.5701C40.9037 37.2497 40.3888 37.8333 39.7587 38.2713C39.1287 38.7093 38.4023 38.9888 37.6412 39.0859L44.5919 46L40.0811 46L33.1707 39.1263L12.8275 39.1263L5.91808 46L1.4082 46L8.41522 39.0296C7.70186 38.8847 7.03117 38.5783 6.45457 38.134C5.87797 37.6897 5.41078 37.1192 5.08882 36.4663C4.76687 35.8135 4.59871 35.0956 4.59722 34.3676L4.59722 4.75959C4.59722 2.13008 6.74045 0 9.38122 0L37.0206 0ZM38.6156 25.9083L7.78624 25.9083L7.78624 34.3676C7.78624 35.2435 8.49971 35.9542 9.38122 35.9542L37.0206 35.9542C37.9012 35.9542 38.6156 35.2435 38.6156 34.3676L38.6156 25.9083ZM13.6339 29.0804C14.3933 29.0804 15.0955 29.4841 15.4748 30.1375C15.6614 30.4587 15.7596 30.8236 15.7596 31.195C15.7596 31.5665 15.6614 31.9314 15.4748 32.2526C15.2874 32.5747 15.0188 32.8419 14.6957 33.0276C14.3726 33.2132 14.0065 33.3108 13.6339 33.3106C13.2616 33.3116 12.8957 33.2145 12.5728 33.0293C12.2499 32.844 11.9815 32.577 11.7945 32.2551C11.6075 31.9332 11.5085 31.5678 11.5075 31.1955C11.5085 30.8232 11.6075 30.4578 11.7945 30.1359C11.9815 29.814 12.2499 29.547 12.5728 29.3617C12.8957 29.1765 13.2616 29.0795 13.6339 29.0804ZM32.7689 29.0804C33.5284 29.0804 34.2306 29.4841 34.6099 30.1375C34.7964 30.4587 34.8947 30.8236 34.8947 31.195C34.8947 31.5665 34.7964 31.9314 34.6099 32.2526C34.4225 32.5747 34.1538 32.8419 33.8308 33.0276C33.5077 33.2132 33.1416 33.3108 32.7689 33.3106C32.3967 33.3116 32.0307 33.2145 31.7078 33.0293C31.3849 32.844 31.1165 32.577 30.9295 32.2551C30.7426 31.9332 30.6436 31.5678 30.6426 31.1955C30.6436 30.8232 30.7426 30.4578 30.9295 30.1359C31.1165 29.814 31.3849 29.547 31.7078 29.3617C32.0307 29.1765 32.3967 29.0795 32.7689 29.0804ZM21.6069 11.1029L7.7853 11.1029L7.7853 22.7353L21.605 22.7353L21.605 11.1038L21.6069 11.1029ZM38.6156 11.1029L24.7959 11.1029L24.7959 22.7353L38.6147 22.7353L38.6147 11.1038L38.6156 11.1029ZM37.0206 3.17306L9.38122 3.17306C8.50065 3.17306 7.78624 3.88371 7.78624 4.75959L7.78624 7.93265L38.6156 7.93265L38.6156 4.75959C38.6156 3.88371 37.9022 3.17306 37.0207 3.17306L37.0206 3.17306Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Transport_Industry',
                },
                {
                  name: this.$t('message.header.industryName9'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 51 52" width="51.000000" height="52.000000" fill="none">
                    <rect id="园区运维 7" width="51.000000" height="52.000000" x="0.000000" y="0.000000" />
                    <path
                      id="矢量 124"
                      d="M33.0013 34.1136C32.7634 33.871 32.4562 33.7114 32.1238 33.6577C31.7914 33.604 31.4509 33.659 31.1511 33.8148C30.8513 33.9706 30.6075 34.2191 30.4547 34.5248C30.3019 34.8306 30.248 35.1777 30.3006 35.5166C30.3533 35.8555 30.5098 36.1687 30.7477 36.4113L36.3259 42.0988C36.5638 42.3415 36.871 42.501 37.2034 42.5547C37.5358 42.6084 37.8763 42.5534 38.1761 42.3976C38.4759 42.2419 38.7197 41.9933 38.8725 41.6876C39.0253 41.3819 39.0792 41.0347 39.0265 40.6958C38.9739 40.3569 38.8174 40.0437 38.5794 39.8011L33.0013 34.1136ZM35.5051 29.0273C35.8482 26.8428 35.6193 24.6046 34.8415 22.5392C34.0638 20.4738 32.7649 18.6545 31.0762 17.2653C29.3875 15.8761 27.3689 14.9662 25.2246 14.6279C23.0802 14.2895 20.8863 14.5346 18.8647 15.3383C18.6176 15.4361 18.3982 15.5952 18.2266 15.8013C18.0551 16.0074 17.9367 16.2539 17.8822 16.5184C17.8278 16.783 17.839 17.0572 17.9148 17.3162C17.9906 17.5753 18.1287 17.8109 18.3165 18.0017L23.1886 22.9693C23.3866 23.1709 23.529 23.4221 23.6015 23.6976C23.674 23.9731 23.674 24.2633 23.6015 24.5388C23.529 24.8143 23.3866 25.0655 23.1886 25.2671L21.6283 26.858C21.4306 27.0598 21.1843 27.2051 20.914 27.279C20.6438 27.3529 20.3592 27.3529 20.089 27.279C19.8188 27.2051 19.5724 27.0598 19.3747 26.858L14.4867 21.8741C14.2999 21.6835 14.0695 21.5434 13.8164 21.4662C13.5632 21.389 13.2952 21.3771 13.0365 21.4318C12.7777 21.4864 12.5363 21.6058 12.3341 21.7791C12.1318 21.9525 11.975 22.1744 11.8777 22.425C11.079 24.4826 10.8276 26.7189 11.1489 28.9074C11.4703 31.096 12.353 33.1592 13.7077 34.8881C15.0624 36.6171 16.841 37.9504 18.8636 38.7532C20.8861 39.556 23.0808 39.7998 25.2254 39.4598L32.4881 46.865C33.3882 47.7831 34.5094 48.4435 35.7392 48.7798C36.969 49.116 38.2639 49.1161 39.4937 48.7803C40.7235 48.4444 41.845 47.7843 42.7453 46.8664C43.6456 45.9484 44.293 44.805 44.6224 43.551C44.9518 42.2971 44.9516 40.9768 44.6219 39.7229C44.2921 38.469 43.6444 37.3258 42.7439 36.4081L35.5051 29.0273ZM40.4903 44.5672C39.9859 45.0815 39.3576 45.4513 38.6686 45.6395C37.9796 45.8277 37.2541 45.8277 36.565 45.6395C35.876 45.4513 35.2477 45.0815 34.7433 44.5672L26.2597 35.9173L25.3991 36.1205C23.9931 36.4527 22.53 36.4405 21.1295 36.0847C19.7291 35.729 18.4313 35.0399 17.3425 34.0739C16.2538 33.1079 15.4051 31.8926 14.866 30.5276C14.3269 29.1625 14.1128 27.6867 14.2413 26.221L17.1212 29.1573C17.7147 29.7626 18.4539 30.1978 19.2647 30.4193C20.0755 30.6409 20.9292 30.6409 21.7399 30.4193C22.5507 30.1978 23.29 29.7626 23.8835 29.1573L25.4437 27.5665C26.0373 26.9613 26.4642 26.2076 26.6815 25.3809C26.8987 24.5542 26.8987 23.6838 26.6815 22.8571C26.4642 22.0305 26.0373 21.2767 25.4437 20.6716L22.5925 17.7645C24.0294 17.6438 25.4738 17.8717 26.8077 18.4295C28.1416 18.9873 29.327 19.8592 30.2669 20.9739C31.2068 22.0885 31.8746 23.4142 32.2155 24.8425C32.5564 26.2708 32.5608 27.7611 32.2283 29.1915L32.0243 30.0738L40.4919 38.7075C42.0761 40.326 42.0761 42.9487 40.4903 44.5672L40.4903 44.5672ZM47.0486 21.4971L28.9596 3.05333C28.3657 2.44889 27.6263 2.01428 26.8157 1.79309C26.0051 1.5719 25.1517 1.5719 24.3411 1.79309C23.5305 2.01428 22.7912 2.44889 22.1973 3.05333L4.10821 21.4971C3.43734 22.1818 2.98146 23.0545 2.79858 24.0042C2.61571 24.9539 2.71413 25.9376 3.08131 26.8301C3.44849 27.7226 4.06782 28.4835 4.86046 29.016L4.86046 45.5C4.86046 48.1877 7.00565 50.375 9.64171 50.375L25.5792 50.375C25.9158 50.375 26.2437 50.2663 26.516 50.0646C26.7883 49.8629 26.991 49.5785 27.095 49.2521C27.199 48.9257 27.199 48.5742 27.095 48.2478C26.991 47.9214 26.7883 47.637 26.516 47.4353C26.2437 47.2336 25.9158 47.125 25.5792 47.125L9.64171 47.125C8.76356 47.125 8.04796 46.397 8.04796 45.5L8.04796 28.0182C8.04796 27.3243 7.61606 26.7068 6.97218 26.481C6.71628 26.3915 6.48692 26.2372 6.30568 26.0324C6.12445 25.8276 5.99732 25.5792 5.93626 25.3105C5.8752 25.0418 5.88222 24.7617 5.95667 24.4965C6.03111 24.2314 6.17052 23.9899 6.36178 23.7948L24.4508 5.35108C24.649 5.14964 24.8955 5.00482 25.1658 4.93111C25.4361 4.85741 25.7207 4.85741 25.991 4.93111C26.2613 5.00482 26.5079 5.14964 26.706 5.35108L44.7951 23.7965C45.0963 24.102 45.262 24.5098 45.262 24.9453C45.2632 25.284 45.16 25.6144 44.967 25.89C44.7739 26.1656 44.5008 26.3723 44.1862 26.481C43.8721 26.5909 43.5994 26.7982 43.4062 27.0737C43.2131 27.3493 43.1091 27.6795 43.1089 28.0182L43.1089 31.9052C43.1089 32.2484 43.2154 32.5827 43.4132 32.8604C43.6111 33.138 43.89 33.3446 44.2101 33.4507C44.5302 33.5567 44.875 33.5567 45.1951 33.4507C45.5152 33.3446 45.7942 33.138 45.992 32.8604C46.1898 32.5827 46.2964 32.2484 46.2964 31.9052L46.2964 29.0176C46.9597 28.5755 47.5041 27.9715 47.8802 27.2603C48.2562 26.5491 48.4519 25.7533 48.4495 24.9453C48.4495 23.6421 47.9523 22.4168 47.0486 21.4971Z"
                      fill="rgb(0,0,0)"
                      fill-rule="nonzero"
                    />
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Machinery_Industry',
                },
                {
                  name: this.$t('message.header.industryName10'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 61" width="54.000000" height="61.000000" fill="none">
                    <rect id="饮料 1" width="54.000000" height="61.000000" x="0.000000" y="0.000000"/>
                    <path id="矢量 128111" d="M16.3829 4.79932L27.0012 4.79932L27.0012 8.22446L16.3829 8.22446L16.3829 4.79932ZM45.2029 21.9336L40.9456 9.93794L13.0544 9.93794L8.79883 21.9336L11.1866 21.9336L14.226 56.2005L39.7755 56.2005L42.815 21.9336L45.2029 21.9336L45.2029 21.9336ZM38.8898 13.3664L40.7147 18.5051L13.287 18.5051L15.1103 13.3664L38.8898 13.3664L38.8898 13.3664ZM15.3059 33.926L38.6943 33.926L38.238 39.0661L15.7622 39.0661L15.3059 33.926ZM16.9784 52.7754L16.0658 42.493L37.9329 42.493L37.0233 52.7754L16.9784 52.7754ZM38.9994 30.5008L15.0023 30.5008L14.2424 21.9336L39.7578 21.9336L38.9994 30.5008Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Daily_Chemicals_Industry',
                },
                {
                  name: this.$t('message.header.industryName11'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 54" width="54.000000" height="54.000000" fill="none">
                    <rect id="钢厂-steel-mill-bold 1" width="54.000000" height="53.999996" x="0.000000" y="0.000000"/>
                    <path id="矢量 128124" d="M20.3508 14.0873C21.4645 14.0873 22.3842 14.953 22.4551 16.0634L23.5013 32.5165L27.5902 31.5968L28.6685 24.3321C28.7205 23.9817 28.8815 23.6565 29.1287 23.4027C29.3758 23.1489 29.6966 22.9793 30.0455 22.918L30.2429 22.8944L40.2548 22.3341C40.5199 22.3194 40.7846 22.3674 41.0276 22.4742C41.2706 22.581 41.485 22.7437 41.6533 22.9489C41.8216 23.1542 41.9392 23.3962 41.9963 23.6554L42.9008 27.751L45.589 27.157C46.8715 26.8532 48.154 27.5822 48.5708 28.804L48.6383 29.0402C48.6839 29.2292 48.7058 29.4267 48.7058 29.6427L48.5118 45.9827C48.5118 47.3817 47.3761 48.5157 45.9738 48.5157L22.72 48.4701C22.6441 48.4701 22.5699 48.465 22.4973 48.4549L22.3792 48.4667L22.2864 48.4701L7.44141 48.4701C6.27535 48.4701 5.33035 47.5251 5.33203 46.2865L5.33878 46.1751L7.99491 16.0127C8.02566 15.6646 8.14241 15.3296 8.33466 15.0378C8.52691 14.746 8.78865 14.5066 9.09636 14.3409C9.40406 14.1753 9.74809 14.0887 10.0975 14.089L20.3508 14.0873ZM39.0095 25.7834L31.8038 26.1867L30.7593 33.237C30.7143 33.539 30.5881 33.8231 30.3944 34.0591C30.2006 34.295 29.9465 34.474 29.659 34.5769L29.4599 34.636L24.119 35.8358L24.3653 45.0985L45.1452 45.1373L45.319 30.672L42.0453 31.3977L41.8563 31.4348C41.5773 31.4747 41.2928 31.4441 41.0287 31.3458C40.7646 31.2475 40.5293 31.0846 40.3443 30.872C40.1593 30.6594 40.0305 30.4038 39.9697 30.1287L39.0078 25.7834L39.0095 25.7834ZM19.5323 23.2656L10.7438 23.2656L8.8201 45.0951L20.9228 45.0968L19.5323 23.2656L19.5323 23.2656ZM19.1611 17.4623L11.2552 17.4623L11.0408 19.8923L19.318 19.8923L19.1628 17.4623L19.1611 17.4623ZM26.1254 3.94879C26.4649 3.98908 26.7841 4.13152 27.0408 4.35725C27.2975 4.58298 27.4797 4.88136 27.5631 5.21288C27.6464 5.54441 27.6272 5.89344 27.5078 6.21377C27.3884 6.53411 27.1746 6.81063 26.8946 7.00674C26.6146 7.20285 26.2816 7.30929 25.9398 7.31198L25.7423 7.30185C24.956 7.21073 24.367 7.38623 23.8507 7.83848C23.665 7.99672 23.5261 8.20271 23.449 8.43416L23.1335 9.28467L23.093 9.38423C22.7509 10.2451 22.1716 10.9912 21.4223 11.5358C19.7686 12.7778 17.8718 12.7778 16.1573 11.5628C15.8764 11.3531 15.6678 11.0612 15.5604 10.7275C15.453 10.3938 15.4521 10.035 15.558 9.70081C15.6638 9.36664 15.8711 9.07373 16.1511 8.86277C16.431 8.6518 16.7697 8.53325 17.1201 8.52357C17.4705 8.5139 17.8153 8.61359 18.1064 8.80879C18.6397 9.18679 18.9282 9.18679 19.3957 8.83579C19.6043 8.69213 19.7742 8.49908 19.8901 8.27385L20.0082 8.00385L20.1263 7.68323C20.5145 6.58635 20.8368 5.99067 21.6232 5.30048C22.8702 4.20867 24.4109 3.75304 26.1237 3.94879L26.1254 3.94879ZM17.5985 3.84079C17.9502 3.88406 18.2793 4.03696 18.5393 4.2778C18.7992 4.51864 18.9768 4.8352 19.0467 5.1826C19.1166 5.52999 19.0754 5.89059 18.929 6.21326C18.7825 6.53592 18.5381 6.80429 18.2306 6.9803C17.923 7.1563 17.5678 7.23102 17.2154 7.19385C16.429 7.10442 15.8384 7.27823 15.322 7.73217C15.0993 7.92792 15.0149 8.04773 14.8799 8.38185L14.8023 8.58773C14.3821 9.7116 13.972 10.3579 12.9646 11.1139C11.3092 12.3542 9.41241 12.3542 7.6996 11.1392C7.42381 10.9277 7.22007 10.6362 7.11623 10.3045C7.01238 9.97276 7.01348 9.61709 7.1194 9.28604C7.22531 8.955 7.43086 8.66474 7.70796 8.45492C7.98506 8.2451 8.32019 8.12597 8.66755 8.1138C9.01491 8.10162 9.35755 8.19701 9.64866 8.38692C10.1802 8.76323 10.4705 8.76323 10.9379 8.41392C11.2923 8.14729 11.3986 8.01567 11.5623 7.60392L11.645 7.3896C12.0044 6.42773 12.3335 5.86242 13.0962 5.19585C14.3416 4.10067 15.884 3.64504 17.5968 3.84079L17.5985 3.84079Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Chemical_Industry',
                },
                {
                  name: this.$t('message.header.industryName12'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 54" width="54.000000" height="54.000000" fill="none">
                    <rect id="司法类_监狱 1" width="54.000000" height="54.000000" x="0.000000" y="0.000000"/>
                    <path id="矢量 128138" d="M47.25 13.5L47.25 3.375L37.125 3.375L37.125 10.125L30.375 10.125L30.375 3.375L20.25 3.375L20.25 10.125L13.5 10.125L13.5 3.375L3.375 3.375L3.375 13.5L6.75 13.5L6.75 47.25L3.375 47.25L3.375 50.625L6.75 50.625L16.9459 50.625L33.8209 50.625L43.875 50.625L47.25 50.625L47.25 47.25L43.875 47.25L43.875 13.5L47.25 13.5ZM40.5 6.75L43.875 6.75L43.875 10.125L40.5 10.125L40.5 6.75ZM23.625 6.75L27 6.75L27 10.125L23.625 10.125L23.625 6.75ZM6.75 6.75L10.125 6.75L10.125 10.125L6.75 10.125L6.75 6.75ZM20.25 47.25L20.25 30.375L30.375 30.375L30.375 47.25L20.25 47.25ZM40.5 47.25L33.75 47.25L33.75 27L16.875 27L16.875 47.25L10.125 47.25L10.125 13.5L13.5 13.5L20.25 13.5L30.375 13.5L37.125 13.5L40.5 13.5L40.5 47.25ZM13.5 16.875L16.875 16.875L16.875 20.25L13.5 20.25L13.5 16.875ZM23.625 16.875L27 16.875L27 20.25L23.625 20.25L23.625 16.875ZM33.75 16.875L37.125 16.875L37.125 20.25L33.75 20.25L33.75 16.875Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Municipal_Public_Service_Industry',
                },
                {
                  name: this.$t('message.header.industryName13'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 54" width="54.000000" height="54.000000" fill="none">
                    <rect id="洗衣机 1" width="54.000000" height="54.000000" x="0.000000" y="0.000000"/>
                    <path id="矢量 128103" d="M43.875 1.6875L10.125 1.6875C8.26369 1.6875 6.75 3.20119 6.75 5.0625L6.75 48.9375C6.75 50.7988 8.26369 52.3125 10.125 52.3125L43.875 52.3125C45.7363 52.3125 47.25 50.7988 47.25 48.9375L47.25 5.0625C47.25 3.20119 45.7363 1.6875 43.875 1.6875ZM10.125 5.0625L43.875 5.0625L43.875 12.1635L10.125 12.1635L10.125 5.0625ZM10.125 48.9375L10.125 15.5385L43.875 15.5385L43.8784 48.9375L10.125 48.9375ZM27 18.5625C19.5564 18.5625 13.5 24.6189 13.5 32.0625C13.5 39.5061 19.5564 45.5625 27 45.5625C34.4436 45.5625 40.5 39.5061 40.5 32.0625C40.5 24.6189 34.4436 18.5625 27 18.5625ZM27 42.1875C21.4161 42.1875 16.875 37.6464 16.875 32.0625C16.875 26.4786 21.4161 21.9375 27 21.9375C32.5839 21.9375 37.125 26.4786 37.125 32.0625C37.125 37.6464 32.5839 42.1875 27 42.1875ZM23.8241 24.597C22.8628 24.9942 21.9899 25.5781 21.2557 26.3149C20.5182 27.0494 19.9337 27.923 19.5362 28.8849C19.4304 29.1413 19.3893 29.4197 19.4165 29.6956C19.4438 29.9716 19.5386 30.2366 19.6925 30.4673C19.8465 30.6979 20.0548 30.8871 20.2992 31.0182C20.5436 31.1492 20.8164 31.2181 21.0938 31.2187C21.4276 31.2193 21.754 31.1206 22.0317 30.9352C22.3093 30.7498 22.5256 30.4861 22.653 30.1776C22.8812 29.6253 23.2161 29.1236 23.6386 28.7011C24.0611 28.2786 24.5628 27.9437 25.1151 27.7155C25.4443 27.5792 25.722 27.3421 25.9083 27.0383C26.0946 26.7345 26.1799 26.3795 26.152 26.0242C26.1241 25.6689 25.9845 25.3316 25.7531 25.0605C25.5217 24.7895 25.2104 24.5987 24.8639 24.5154C24.5174 24.4321 24.1534 24.4607 23.8241 24.597L23.8241 24.597ZM40.5 7.101L33.75 7.101C33.3936 7.101 33.0464 7.21382 32.7581 7.42328C32.4698 7.63275 32.2552 7.92811 32.1451 8.26703C32.035 8.60596 32.035 8.97104 32.1451 9.30997C32.2552 9.64889 32.4698 9.94425 32.7581 10.1537C33.0464 10.3632 33.3936 10.476 33.75 10.476L40.5 10.476C40.8564 10.476 41.2036 10.3632 41.4919 10.1537C41.7802 9.94425 41.9948 9.64889 42.1049 9.30997C42.215 8.97104 42.215 8.60596 42.1049 8.26703C41.9948 7.92811 41.7802 7.63275 41.4919 7.42328C41.2036 7.21382 40.8564 7.101 40.5 7.101Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Home_Appliance_Industry',
                },
                {
                  name: this.$t('message.header.industryName14'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 54" width="54.000000" height="54.000000" fill="none">
                    <rect id="冶金矿产 1" width="54.000000" height="53.999996" x="0.000000" y="0.000000"/>
                    <path id="矢量 128121" d="M35.4007 27.0012C34.4721 27.0012 33.7148 27.7552 33.7148 28.687C33.7148 29.6187 34.4721 30.3728 35.4007 30.3728C36.3357 30.3728 37.0865 29.6188 37.0865 28.687C37.0864 27.7552 36.3357 27.0012 35.4007 27.0012Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128122" d="M52.2589 33.7444L48.8874 33.7444L48.8775 33.7444C48.8742 33.5452 48.8511 33.3411 48.7754 33.1435L42.0324 15.443C41.7854 14.7894 41.1565 14.3581 40.4585 14.3581L33.7155 14.3581C33.3072 14.3581 32.9121 14.5063 32.6059 14.7746L30.5909 16.5377L24.9409 9.12136C24.5194 8.56656 23.7885 8.32952 23.13 8.52538L9.64386 12.4599C9.02486 12.641 8.56063 13.158 8.45195 13.7934L5.08043 33.4596C5.06394 33.5567 5.0903 33.6489 5.0903 33.7444L5.05736 33.7444L1.68579 33.7444C0.757283 33.7444 0 34.4984 0 35.4302C0 36.362 0.757283 37.116 1.68579 37.116L4.3824 37.116L8.42893 46.1045C8.42893 46.7268 9.18621 47.2306 10.1147 47.2306L10.4242 47.2306C10.2366 47.7591 10.1147 48.3221 10.1147 48.9164C10.1147 51.7118 12.38 53.9737 15.172 53.9737C17.9707 53.9737 20.2293 51.7118 20.2293 48.9164C20.2293 48.3221 20.1075 47.7591 19.9198 47.2306L34.025 47.2306C33.8373 47.7591 33.7155 48.3221 33.7155 48.9164C33.7155 51.7118 35.9808 53.9737 38.7729 53.9737C41.5715 53.9737 43.8302 51.7118 43.8302 48.9164C43.8302 48.3221 43.7083 47.7591 43.5207 47.2306L43.8302 47.2306C44.7653 47.2306 45.516 46.7268 45.516 46.1045L49.5625 37.116L52.2591 37.116C53.1942 37.116 53.9449 36.362 53.9449 35.4302C53.9449 34.4984 53.194 33.7444 52.2589 33.7444ZM11.5996 15.4017L22.9622 12.0862L29.0039 20.0162C29.2871 20.3866 29.7118 20.6237 30.1761 20.6714C30.6304 20.701 31.1012 20.5693 31.4535 20.2632L34.3476 17.7296L39.2963 17.7296L45.3974 33.7444L8.45529 33.7444L11.5996 15.4017ZM16.8578 48.9163C16.8578 49.8464 16.1005 50.6021 15.172 50.6021C14.2435 50.6021 13.4862 49.8464 13.4862 48.9163C13.4862 47.9861 14.2435 47.2305 15.172 47.2305C16.1005 47.2305 16.8578 47.9861 16.8578 48.9163ZM40.4585 48.9163C40.4585 49.8464 39.7013 50.6021 38.7728 50.6021C37.8443 50.6021 37.087 49.8464 37.087 48.9163C37.087 47.9861 37.8443 47.2305 38.7728 47.2305C39.7013 47.2305 40.4585 47.9861 40.4585 48.9163ZM42.8292 43.859L11.1156 43.859L8.07991 37.1159L45.8649 37.1159L42.8292 43.859Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128123" d="M21.4211 22.4377C20.7626 21.7792 19.6958 21.7792 19.0373 22.4377L15.6658 25.8093C15.0072 26.4678 15.0072 27.5345 15.6658 28.193C16.3242 28.8516 17.391 28.8516 18.0495 28.193L20.2292 26.0134L22.4089 28.193C22.7381 28.5223 23.1694 28.687 23.6007 28.687C24.0321 28.687 24.4634 28.5223 24.7926 28.193C25.4511 27.5346 25.4511 26.4678 24.7926 25.8093L21.4211 22.4377Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  // 冶炼
                  routerPath: '/Smelting_Industry',
                },
                {
                  name: this.$t('message.header.industryName15'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 54" width="54.000000" height="54.000000" fill="none">
                    <rect id="事业快车改 1" width="54.000000" height="53.999996" x="0.000000" y="0.000000"/>
                    <path id="矢量 128135" d="M51.2004 25.725L38.5854 12.2089L38.5735 12.1984C38.5591 12.1833 38.5442 12.1688 38.5287 12.1549L38.4931 12.1206C38.4787 12.1075 38.4628 12.0969 38.447 12.0851L38.4036 12.0521L38.3588 12.0232L38.3087 11.9929L38.26 11.9691L38.2099 11.9441L38.1572 11.9244C38.1408 11.9176 38.1241 11.9115 38.1072 11.9059C38.0887 11.8993 38.069 11.8954 38.0505 11.8901L37.9991 11.8769L37.9451 11.8677C37.9263 11.8641 37.9075 11.861 37.8885 11.8585L37.8384 11.8545C37.8169 11.8531 37.7954 11.8522 37.7739 11.8519L37.7567 11.8506L1.13821 11.8506C0.937344 11.8515 0.740261 11.9053 0.566803 12.0066C0.393346 12.1079 0.249634 12.2531 0.150135 12.4276C0.0506357 12.6021 -0.00114013 12.7998 1.90481e-05 13.0006L1.90481e-05 36.8843C-0.00053389 37.0576 0.0382157 37.2287 0.113353 37.3849C0.18849 37.541 0.298059 37.6781 0.433817 37.7858C0.569575 37.8935 0.727987 37.969 0.897138 38.0067C1.08157 38.1318 1.30157 38.1977 1.5242 38.1977L47.1851 38.1977C50.9501 38.1977 54.0116 35.1032 54.0116 31.3C54.013 30.2154 53.7593 29.1457 53.2709 28.1772C52.7826 27.2087 52.0733 26.3687 51.2004 25.725ZM40.4692 24.401L32.9932 24.401L32.9932 17.996L40.6325 17.996C40.7015 17.9959 40.7703 17.9893 40.838 17.9763L46.8346 24.401L40.4692 24.401L40.4692 24.401ZM47.1851 35.8963L2.27641 35.8963L2.27641 14.1481L37.268 14.1481L38.7131 15.6959L31.8537 15.6959C31.653 15.6971 31.4561 15.7511 31.2828 15.8524C31.1096 15.9538 30.9661 16.099 30.8667 16.2734C30.7673 16.4478 30.7156 16.6453 30.7168 16.846L30.7168 25.5498C30.7168 26.1847 31.2266 26.6998 31.8537 26.6998L47.1837 26.6998C48.0795 26.6985 48.9529 26.9659 49.6986 27.4665L49.717 27.4876C49.8158 27.593 49.9331 27.6786 50.0622 27.7379C50.5864 28.171 51.0083 28.7148 51.2975 29.3302C51.5868 29.9456 51.7362 30.6174 51.7352 31.2974C51.7352 33.8346 49.6933 35.8963 47.1837 35.8963L47.1851 35.8963Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128136" d="M14.6925 15.8022L6.16127 15.8022C5.96294 15.8025 5.76818 15.8549 5.59658 15.9544C5.42498 16.0538 5.2826 16.1967 5.18377 16.3686C5.08494 16.5406 5.03315 16.7355 5.03362 16.9339L5.03362 25.5006C5.03362 26.125 5.53816 26.6322 6.16127 26.6322L14.6925 26.6322C14.8909 26.632 15.0858 26.5794 15.2575 26.4799C15.4292 26.3803 15.5716 26.2372 15.6704 26.0651C15.7692 25.8929 15.8208 25.6978 15.8201 25.4993L15.8201 16.9352C15.8208 16.7367 15.7692 16.5415 15.6704 16.3694C15.5716 16.1972 15.4292 16.0542 15.2575 15.9546C15.0858 15.855 14.8909 15.8025 14.6925 15.8022ZM13.5661 24.369L7.28761 24.369L7.28761 18.0655L13.5661 18.0655L13.5661 24.369L13.5661 24.369ZM27.5722 15.8022L19.0397 15.8022C18.8416 15.8027 18.647 15.8553 18.4756 15.9548C18.3042 16.0543 18.162 16.1972 18.0633 16.369C17.9646 16.5409 17.9129 16.7357 17.9134 16.9339L17.9134 25.5006C17.9134 26.125 18.4179 26.6322 19.0397 26.6322L27.5722 26.6322C27.7706 26.6318 27.9653 26.5791 28.1368 26.4794C28.3082 26.3798 28.4505 26.2368 28.5491 26.0647C28.6477 25.8926 28.6993 25.6976 28.6986 25.4993L28.6986 16.9352C28.6995 16.7368 28.6481 16.5417 28.5495 16.3695C28.4509 16.1973 28.3086 16.0542 28.137 15.9546C27.9655 15.855 27.7706 15.8025 27.5722 15.8022ZM26.4446 24.369L20.1661 24.369L20.1661 18.0655L26.4446 18.0655L26.4446 24.369ZM46.2971 39.8875L1.12766 39.8875C0.929629 39.8877 0.735146 39.94 0.563726 40.0391C0.392306 40.1383 0.249981 40.2808 0.151034 40.4523C0.052087 40.6239 -1.97528e-07 40.8184 7.85373e-10 41.0164C7.85373e-10 41.6409 0.504547 42.148 1.12634 42.148L46.2985 42.148C46.4966 42.1476 46.6912 42.095 46.8626 41.9955C47.034 41.896 47.1762 41.7531 47.2749 41.5813C47.3736 41.4094 47.4253 41.2146 47.4248 41.0164C47.4253 40.8183 47.3736 40.6235 47.2749 40.4516C47.1762 40.2797 47.034 40.1369 46.8626 40.0374C46.6912 39.9379 46.4966 39.8853 46.2985 39.8848L46.2971 39.8875Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/High-speed_Train_Production_Industry',
                },
                {
                  name: this.$t('message.header.industryName16'),
                  icon: `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 54 54" width="54.000000" height="54.000000" fill="none">
                    <rect id="Icon - 医院 1" width="54.000000" height="53.999996" x="0.000000" y="0.000000"/>
                    <path id="矢量 128145" d="M27.3945 10.7314C27.9746 10.7314 28.4492 11.2061 28.4492 11.7861L28.4492 43.2686L12.1016 43.2686L12.1016 11.7861C12.1016 11.2061 12.5762 10.7314 13.1562 10.7314L27.3945 10.7314ZM27.3945 8.09473L13.1562 8.09473C11.1154 8.09473 9.46484 9.74531 9.46484 11.7861L9.46484 45.9053L31.0859 45.9053L31.0859 11.7861C31.0859 9.74531 29.4354 8.09473 27.3945 8.09473Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128146" d="M45.957 45.9053L8.04102 45.9053C7.31328 45.9053 6.72266 45.3146 6.72266 44.5869C6.72266 43.8592 7.31328 43.2686 8.04102 43.2686L45.957 43.2686C46.6848 43.2686 47.2754 43.8592 47.2754 44.5869C47.2754 45.3146 46.6848 45.9053 45.957 45.9053ZM17.5859 21.0674C16.8582 21.0674 16.2676 20.4768 16.2676 19.749L16.2676 17.5342C16.2676 16.8064 16.8582 16.2158 17.5859 16.2158C18.3137 16.2158 18.9043 16.8064 18.9043 17.5342L18.9043 19.749C18.9043 20.4768 18.3137 21.0674 17.5859 21.0674ZM22.9648 21.0674C22.2371 21.0674 21.6465 20.4768 21.6465 19.749L21.6465 17.5342C21.6465 16.8064 22.2371 16.2158 22.9648 16.2158C23.6926 16.2158 24.2832 16.8064 24.2832 17.5342L24.2832 19.749C24.2832 20.4768 23.6926 21.0674 22.9648 21.0674ZM17.5859 30.5068C16.8582 30.5068 16.2676 29.9162 16.2676 29.1885L16.2676 26.9736C16.2676 26.2459 16.8582 25.6553 17.5859 25.6553C18.3137 25.6553 18.9043 26.2459 18.9043 26.9736L18.9043 29.1885C18.9043 29.9162 18.3137 30.5068 17.5859 30.5068ZM22.9648 30.5068C22.2371 30.5068 21.6465 29.9162 21.6465 29.1885L21.6465 26.9736C21.6465 26.2459 22.2371 25.6553 22.9648 25.6553C23.6926 25.6553 24.2832 26.2459 24.2832 26.9736L24.2832 29.1885C24.2832 29.9162 23.6926 30.5068 22.9648 30.5068Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128147" d="M21.8848 38.1533L21.8848 43.2686L18.668 43.2686L18.668 38.1533L21.8848 38.1533ZM23.4879 35.5166L17.0596 35.5166C16.49 35.5166 16.0312 35.9807 16.0312 36.5449L16.0312 45.9053L24.5215 45.9053L24.5215 36.5449C24.5215 35.9807 24.0574 35.5166 23.4879 35.5166ZM34.9365 32.7744L29.9268 32.7744C29.199 32.7744 28.6084 32.1838 28.6084 31.4561C28.6084 30.7283 29.199 30.1377 29.9268 30.1377L34.9365 30.1377C35.6643 30.1377 36.2549 30.7283 36.2549 31.4561C36.2549 32.1838 35.6643 32.7744 34.9365 32.7744ZM34.9365 38.2061L29.9268 38.2061C29.199 38.2061 28.6084 37.6154 28.6084 36.8877C28.6084 36.16 29.199 35.5693 29.9268 35.5693L34.9365 35.5693C35.6643 35.5693 36.2549 36.16 36.2549 36.8877C36.2549 37.6154 35.6643 38.2061 34.9365 38.2061ZM43.2158 45.0088C42.4881 45.0088 41.8975 44.4182 41.8975 43.6904L41.8975 26.71C41.8975 25.9822 42.4881 25.3916 43.2158 25.3916C43.9436 25.3916 44.5342 25.9822 44.5342 26.71L44.5342 43.6904C44.5342 44.4182 43.9436 45.0088 43.2158 45.0088Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                    <path id="矢量 128148" d="M45.9578 28.3446C45.7944 28.3446 45.6309 28.3129 45.4727 28.2496L29.4414 21.9215C28.7664 21.6526 28.4342 20.8879 28.6979 20.2129C28.9668 19.5379 29.7315 19.2057 30.4065 19.4694L46.4377 25.7975C47.1127 26.0664 47.445 26.8311 47.1813 27.5061C46.9809 28.0282 46.4852 28.3446 45.9578 28.3446L45.9578 28.3446Z" fill="rgb(1,13,57)" fill-rule="nonzero"/>
                  </svg>`,
                  iconClass: 'w22',
                  routerPath: '/Medical_Service_Industry',
                },
              ],
            },
          ],
        },
        {
          id: 'about',
          name: this.$t('message.header.firstNav4'), // 关于我们
          routerPath: '/About',
        },
        {
          id: 'contact',
          name: this.$t('message.footer.contactUs'), // 联系我们
          routerPath: '/Contact',
        },
        // {
        //   id: 'news',
        //   name: this.$t('message.header.news'), // 新闻动态
        //   routerPath: '/News',
        // },
      ],
      secondNavIndex: -1, // 二级导航索引
      langList: [
        {
          code: 'cn',
          label: '简体中文',
        },
        {
          code: 'en',
          label: 'English',
        },
      ],
      currentLangLabel: '',
      hostName: '',
      mobileMenuShow: false,

      selectMenu: '',
      selectFirstMobileMenu: '',
      selectMobileMenu: '',

      selectStage: '',
      activeProduct: [],
    };
  },
  watch: {
    $route: {
      handler(to, from) {
        // console.log('参数变化:', to);
        localStorage.setItem('firstNavIndex', to.meta.index);
        this.$nextTick(() => {
          this.firstNavIndex = localStorage.getItem('firstNavIndex') || -1;
        });
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.hostName = location.host.substring(location.host.lastIndexOf('.'));
    this.currentLangLabel = this.langList.find(item => item.code == this.currentLang).label || '简体中文';
    this.secondNavIndex = localStorage.getItem('secondNavIndex') || -1;
    if (this.$route.path == '/') {
      localStorage.setItem('firstNavIndex', -1);
    }
    this.$nextTick(() => {
      this.firstNavIndex = localStorage.getItem('firstNavIndex') || -1;
    });
  },
  methods: {
    handleContact() {
      window.location.href =
        'https://p.qiao.baidu.com/cps3/chatIndex?siteToken=66bcd312fd92dc847aef8db34725dea0&speedLogId=163861205504033d2_1638612055040_56142&reqParam=%7B%22from%22%3A0%2C%22sessionid%22%3A%22-100%22%2C%22siteId%22%3A%2212690806%22%2C%22tid%22%3A%22-1%22%2C%22userId%22%3A%2225532310%22%2C%22ttype%22%3A1%2C%22siteConfig%22%3A%7B%22eid%22%3A%2225532310%22%2C%22queuing%22%3A%22%22%2C%22siteToken%22%3A%2266bcd312fd92dc847aef8db34725dea0%22%2C%22userId%22%3A%2225532310%22%2C%22vstProto%22%3A1%2C%22likeVersion%22%3A%22generic%22%2C%22siteId%22%3A%2212690806%22%2C%22online%22%3A%22false%22%2C%22webRoot%22%3A%22https%3A%2F%2Fp.qiao.baidu.com%2Fcps3%2F%22%2C%22bid%22%3A%22163861205529995088%22%2C%22isSmallFlow%22%3A0%2C%22isPreonline%22%3A0%2C%22invited%22%3A0%2C%22origin%22%3A%22%E5%86%85%E9%83%A8%E7%89%A9%E6%B5%81%2F%E5%8E%82%E5%86%85%E7%89%A9%E6%B5%81%2F%E5%9C%BA%E5%86%85%E7%89%A9%E6%B5%81%C2%B7%E7%89%A9%E8%81%94%E7%BD%91%E8%A7%A3%E5%86%B3%E6%96%B9%E6%A1%88-%E5%AE%98%E7%BD%91%20-%20TBL%E5%8D%8E%E6%B8%85%E7%A7%91%E7%9B%9B%E4%BF%A1%E6%81%AF%E6%8A%80%E6%9C%AF%22%7D%2C%22config%22%3A%7B%22themeColor%22%3A%22F84048%22%7D%7D';
    },
    handleProductHover(data) {
      this.selectProductInfo.label = data.name;
      this.selectProductInfo.desc = data.desc;
    },
    handleProductLeave() {
      this.selectProductInfo = {
        label: '',
        desc: '',
      };
    },
    handleSceneHover(data) {
      this.selectSceneInfo.label = data.name;
      this.selectSceneInfo.desc = data.desc;
      this.selectSceneInfo.detailUrl = data.detailUrl;
    },
    thirdNavHover(thirdData) {
      if (thirdData.routerPath == '/customerAnalysis' || thirdData.routerPath == '/painPoints') {
        this.stageHover(1);
      } else if (thirdData.routerPath == '/strategyCoach' || thirdData.routerPath == '/smartPoster') {
        this.stageHover(2);
      } else if (thirdData.routerPath == '/training') {
        this.stageHover(3);
      } else if (thirdData.routerPath == '/simulation' || thirdData.routerPath == '/solutionGenerationPlatform') {
        this.stageHover(4);
      } else if (thirdData.routerPath == '/strategyCoach') {
        this.stageHover(5);
      }
    },
    stageHover(flag) {
      this.selectStage = flag;
      switch (flag) {
        case 1:
          this.activeProduct = ['/customerAnalysis', '/painPoints'];
          break;

        case 2:
          this.activeProduct = ['/strategyCoach', '/smartPoster'];
          break;

        case 3:
          this.activeProduct = ['/training'];
          break;

        case 4:
          this.activeProduct = ['/simulation', '/solutionGenerationPlatform'];
          break;

        case 5:
          this.activeProduct = ['/strategyCoach'];
          break;

        default:
          break;
      }
    },
    menuHover(data) {
      this.selectMenu = data.name;
    },
    menuLeave() {
      this.selectMenu = '';
    },
    toggleMobileMenu() {
      this.mobileMenuShow = !this.mobileMenuShow;
    },
    changeFirstNavIndex(index) {
      this.firstNavIndex = index;
    },
    // 跳转首页
    goHome() {
      this.firstNavIndex = -1;
      this.secondNavIndex = -1;
      localStorage.removeItem('firstNavIndex');
      localStorage.removeItem('secondNavIndex');
      this.$router.push('/');
    },

    // 中英文切换
    changeLanguage(lang) {
      // return;
      this.currentLangLabel = this.langList.find(item => item.code == lang.code).label || '简体中文';
      this.changeAppLanguage(lang.code);
    },
    changeLanguageMobile(lang) {
      this.changeAppLanguage(lang);
    },

    // 登录
    goLogin() {
      window.location.href =
        process.env.NODE_ENV === 'development'
          ? `https://user.xpirory.ai/login?lang=${this.currentLang == 'cn' ? 'zh' : this.currentLang}`
          : `https://user.xpirory.ai/login?lang=${this.currentLang == 'cn' ? 'zh' : this.currentLang}`;
      localStorage.clear();
    },

    // 退出登录
    goLoginOut() {
      this.$confirm(this.$t('message.index.logoutTips'), this.$t('message.tips'), {
        type: 'warning',
      }).then(() => {
        this.$message.success(this.$t('message.index.logoutSuccess'));
        localStorage.clear();
      });
    },

    // 导航
    changeNav(item, index, secondIndex) {
      if (item.id == 'docs') {
        this.goLogin();
        return;
      }
      return;
      this.firstNavIndex = index;
      localStorage.setItem('firstNavIndex', index);
      if (secondIndex !== undefined) {
        this.secondNavIndex = secondIndex;
        localStorage.setItem('secondNavIndex', secondIndex);
      } else {
        this.secondNavIndex = -1;
        localStorage.setItem('secondNavIndex', -1);
      }
      if (item.routerPath) {
        this.$router.push(item.routerPath);
        window.scrollTo({
          top: 0,
          behavior: 'smooth',
        });
      }
      this.mobileMenuShow = false;
    },

    changeFirstMobile(item, index) {
      if (item.id == 'contact' || item.id == 'about') {
        this.$router.push(item.routerPath);
        return;
      }
      if (item.name == this.selectFirstMobileMenu) {
        this.selectFirstMobileMenu = '';
        return;
      }
      this.selectFirstMobileMenu = item.name;
    },

    changeSecondMobile(item, index, secondIndex) {
      if (item.id == 'contact') {
        this.handleThirdClickNew(item);
      }

      if (item.name == this.selectMobileMenu) {
        this.selectMobileMenu = '';
        return;
      }
      this.selectMobileMenu = item.name;
    },

    onStageOver(index) {
      this.activeStage = index;
      this.selectPlatform = [];
      if (index == 0) {
        this.selectPlatform = [0];
      } else if (index == 1) {
        this.selectPlatform = [1, 2];
      } else if (index == 2) {
        this.selectPlatform = [3, 5, 6];
      } else if (index == 3) {
        this.selectPlatform = [7, 9];
      } else if (index == 4) {
        this.selectPlatform = [8];
      } else if (index == 5) {
        this.selectPlatform = [9, 10];
      }
    },
    // 鼠标移入
    onSecondMouseOver(index) {
      this.secondNavIndex = index;
    },
    handleThirdHover(thirdItem) {
      this.hoverPlatform = thirdItem.platformIndex;
      if (thirdItem.platformIndex == 0) {
        this.activeStage = 0;
      } else if (thirdItem.platformIndex == 1 || thirdItem.platformIndex == 2) {
        this.activeStage = 1;
      } else if (thirdItem.platformIndex == 3 || thirdItem.platformIndex == 5 || thirdItem.platformIndex == 6) {
        this.activeStage = 2;
      } else if (thirdItem.platformIndex == 7 || thirdItem.platformIndex == 9) {
        this.activeStage = 3;
      } else if (thirdItem.platformIndex == 8) {
        this.activeStage = 4;
      } else if (thirdItem.platformIndex == 9 || thirdItem.platformIndex == 10) {
        this.activeStage = 5;
      }

      if (this.activeStage == 0) {
        this.selectPlatform = [0];
      } else if (this.activeStage == 1) {
        this.selectPlatform = [1, 2];
      } else if (this.activeStage == 2) {
        this.selectPlatform = [3, 5, 6];
      } else if (this.activeStage == 3) {
        this.selectPlatform = [7, 9];
      } else if (this.activeStage == 4) {
        this.selectPlatform = [8];
      } else if (this.activeStage == 5) {
        this.selectPlatform = [9, 10];
      }
    },
    handleThirdLeave() {
      this.hoverPlatform = '';
    },
    // 三级目录点击
    handleThirdClick(item, index) {
      if (item.children[index].routerPath) {
        this.$router.push(`${item.children[index].routerPath}`);
      }
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      this.mobileMenuShow = false;
    },
    handleThirdClickNew(data) {
      this.$router.push(`${data.routerPath}`);
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
      this.mobileMenuShow = false;
    },
    jumpRoute(data) {
      this.$router.push(`${data}`);
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.earth {
  width: 18px;
  margin-left: 18px;
  margin-right: -9px;
  margin-bottom: -2px;
}
.contact {
  cursor: pointer;
  &:hover {
    color: #276dfb;
  }
}
.w-header {
  width: 100%;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.1);
  .nav-left {
    .logo {
      margin-left: 262px;
      margin-right: 195px;
    }
  }
  .nav-right {
    margin-right: 303px;
    .phone {
      img {
        height: 16px;
        margin-right: 2px;
      }
    }
  }
}

.hidden-block {
  height: 10px;
  background: transparent;
}

.header {
  height: 76px;
  border-bottom: 1px solid #f1f1f1;
  font-size: 14px;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000; /* 确保头部层级最高 */
  background: var(--background-color);

  .logo img {
    height: 38px;
  }

  .nav-left {
    .nav-list {
      gap: 25px;

      .nav-item {
        > .item-name {
          font-size: 1rem;
          font-weight: 500;
          text-align: center;
          height: 76px;
          line-height: 76px;
          color: rgba(1, 13, 57, 0.7);
          box-sizing: border-box;
          &.with-children {
            margin-right: 20px;
          }
        }
      }

      .nav-item.active > .item-name{
        position: relative;
        &::after {
          content: '';
          position: absolute;
          height: 4px;
          background: var(--primary-color);
          bottom: 0;
          left: -10px;
          right: -10px;
        }

        color: var(--text-color);
      }

      .nav-second {
        display: none;
        z-index: 9999;
        position: absolute;
        top: 68px;
        left: 216px;
        &.scenes {
          // display: block;
          .nav-second-list {
            padding-right: 25px;
          }
        }
        &.products {
          // display: block;
          .nav-second-list {
            width: 1546px;
            padding-right: 45px;
            padding-left: 45px;
          }
        }
        &.industrys {
          // display: block;
          left: 370px;
          .nav-second-list {
            width: 945px;
            padding-right: 12px;
            .nav-second-wrap {
              .nav-third {
                justify-content: space-between;
                .nav-third-outer {
                  flex: 0 0 25%;
                  height: 50px;
                }
                .nav-third-item {
                  height: 100%;
                  width: calc(100% - 45px);
                  &.selected,
                  &:hover {
                    .img-box {
                      ::v-deep() {
                        svg {
                          path {
                            fill: #1a64ff;
                          }
                        }
                      }
                    }
                  }
                  &.special {
                    width: 95%;
                  }
                  .item-name {
                    height: 100%;
                  }
                  .img-box {
                    width: 20px;
                    ::v-deep() {
                      svg {
                        width: 20px;
                        margin-bottom: -4px;
                        path {
                          fill: #010d39;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }

        &.about {
          left: 866px;
          .nav-second-list {
            width: 206px;
          }
          .contact:nth-child(1),
          .contact:nth-child(2) {
            margin-bottom: 25px;
          }
        }

        .nav-second-content {
          .nav-second-wrap {
            width: 100%;
          }
          &.products {
            .nav-second-item {
              .item-name {
                padding-left: 12px;
              }
            }
            .nav-third {
              .nav-third-item {
                margin-bottom: 18px;
                .img-box {
                  width: 21px;
                }
              }
              .nav-product-col:not(:last-child) {
                margin-right: 15px;
              }
            }
            .nav-second-wrap:first-child {
              padding-left: 0;
            }
            .nav-second-wrap {
              padding: 0 20px;
              width: 322px;
              position: relative;
              &:not(:last-child):after {
                content: '';
                position: absolute;
                top: 45px;
                bottom: 20px;
                right: -215px;
                width: 350px;
                pointer-events: none;
                background: url('../assets/images/header/divide.svg') center center no-repeat;
                background-size: contain;
              }
            }
            .nav-second-wrap:last-child {
              width: 940px;
              padding-right: 0;
            }
          }
        }

        .nav-second-list {
          width: 1334px;
          border-radius: 9px;
          box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.1);
          background-color: #fff;
          text-align: left;
          color: var(--text-color);
          padding: 32px 57px;
        }

        .nav-second-list * {
          line-height: normal;
          font-size: 15px;

          img {
            vertical-align: middle;
          }
        }
      }

      .nav-item:hover .nav-second.with-children {
        display: block;
        /* 添加标准属性 */
        animation-name: fadeIn 0.25s forwards;
      }

      .nav-second-item {
        text-align: center;
        .item-name {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 25px;
          text-align: left;
          span {
            font-size: 18px;
          }
        }

        .nav-second-item-arrow {
          display: none;
        }
      }

      .nav-third {
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;
        // padding-left: 45px;
        /* 添加标准属性 */
        animation-name: fadeIn;
        animation-duration: 0.25s;
        animation-iteration-count: 1;
        animation-delay: 0s;
        .nav-third-col {
          width: 295px;
          padding-right: 15px;
          margin-right: 10px;
          .nav-third-item {
            position: relative;
            &.withBottomArrow::after {
              content: '';
              position: absolute;
              height: 16px;
              width: 16px;
              bottom: -21px;
              left: 45px;
              background: url('../assets/images/header/to-bottom.svg') center center no-repeat;
            }
            &.withRightArrow::after {
              content: '';
              position: absolute;
              height: 16px;
              width: 16px;
              top: 50%;
              right: -20px;
              transform: translateY(-50%);
              background: url('../assets/images/header/to-right.svg') center center no-repeat;
            }
            &.withTopArrow::after {
              content: '';
              position: absolute;
              height: 16px;
              width: 16px;
              top: -21px;
              left: 45px;
              background: url('../assets/images/header/to-top.svg') center center no-repeat;
            }
          }
          .nav-third-item:not(:last-child) {
            margin-bottom: 24px;
          }
        }
        .nav-third-col:nth-child(2) {
          width: 290px;
          position: relative;
          &::after {
            content: '';
            position: absolute;
            top: 34px;
            bottom: 41px;
            right: -215px;
            width: 350px;
            pointer-events: none;
            background: url('../assets/images/header/divide.svg') center center no-repeat;
            background-size: contain;
          }
        }
        .nav-third-col:nth-child(3) {
          width: 300px;
          padding-left: 10px;
          padding-right: 15px;
          position: relative;
          &::after {
            content: '';
            position: absolute;
            top: 34px;
            bottom: 41px;
            right: -215px;
            width: 350px;
            pointer-events: none;
            background: url('../assets/images/header/divide.svg') center center no-repeat;
            background-size: contain;
          }
        }
        .scene-detail {
          width: 300px;
          padding-left: 30px;
          position: relative;
          z-index: 1;
          .image-box {
            img {
              width: 270px;
            }
          }
          h3 {
            font-size: 18px;
            margin: 22px 0;
            font-weight: normal;
          }
          p {
            font-size: 10px;
            line-height: 12px;
            color: #4a5578;
          }
          .el-button {
            margin-top: 75px;
            color: #276dfb;
            font-size: 16px;
          }
        }
      }

      .nav-third-item {
        width: 100%;
        padding: 10px 12px;
        box-sizing: border-box;
        border-radius: 4px;
        color: var(--text-color);
        .w15 {
          width: 15px;
        }
        .w16 {
          width: 16px;
        }
        .w18 {
          width: 18px;
        }
        .w19 {
          width: 19px;
        }
        .w20 {
          width: 20px;
        }
        .w21 {
          width: 21px;
        }
        .w22 {
          width: 22px;
        }
        .w25 {
          width: 25px;
        }
        &.selected,
        &:hover {
          background: rgba(221, 228, 244, 0.4);
        }

        .item-name {
          cursor: pointer;
          transition: color 0.3s;

          .text-wrap {
            margin: 0 12px;
            .label {
              font-size: 15px;
              font-weight: 500;
            }
            .desc {
              margin-top: 8px;
              font-size: 11px;
              color: #4a5578;
            }
          }
        }
      }
    }
  }

  .nav-right {
    .el-dropdown {
      color: var(--text-color);
    }
  }
}
.drop_toggle {
  i.el-icon-arrow-down {
    color: var(--text-color);
    font-size: 16px;
    margin-left: 6px;
    transition: all 0.3s;
    -webkit-transition: all 0.3s;
  }
  &.menu_arrow i.el-icon-arrow-down {
    -webkit-transform: rotateZ(180deg) !important;
    transform: rotateZ(180deg) !important;
  }
}

.el-dropdown-menu__item:focus,
.el-dropdown-menu__item:not(.is-disabled):hover,
.el-dropdown-menu__item:has(.active) {
  background-color: #ecf5ff;
  color: var(--primary-color);
}

@keyframes fadeIn {
  0% {
    opacity: 0;
    /*初始状态 透明度为0*/
  }

  20% {
    opacity: 0.2;
  }

  50% {
    opacity: 0.5;
    /*中间状态 透明度为0.5*/
  }

  70% {
    opacity: 0.7;
  }

  100% {
    opacity: 1;
    /*结尾状态 透明度为1*/
  }
}
.nav-list-mobile {
  display: flex;
  align-items: center;
  .lang {
    display: flex;
    align-items: center;
    font-size: 60px;
    .lang-item {
      &.active {
        color: #1a64ff;
        font-weight: 550;
        font-size: 64px;
      }
    }
  }
  .icon-wrap {
    .menu {
      width: 70px;
    }
    .menu-off {
      width: 70px;
    }
  }
}
.mobile-menu {
  width: 100vw;
  position: absolute;
  top: 200px;
  right: 0;
  left: 0;
  bottom: 0;
  background: #fff;
  padding: 3rem 0;
  padding-bottom: 180px;
  height: calc(100vh - 200px);
  overflow-y: auto;
  z-index: 999999;
  .nav-item {
    .item-name {
      font-size: 80px;
      padding: 75px 3rem;
      border-bottom: 1px solid #f1f1f1;
    }
    .el-icon-arrow-down {
      font-size: 80px;
    }
  }
  .nav-second-item {
    padding-right: 50px;
    border-bottom: 1px solid #f1f1f1;
    & > div {
      width: 100%;
    }
    .nav-second-item-arrow {
      font-size: 66px;
    }
    .item-name {
      text-indent: 1em;
      width: 100%;
      border: none;
    }
  }
  .nav-third-item {
    width: 100% !important;
    background: #f9ffff;
    .item-name {
      text-indent: 2em;
    }
  }
}
@media only screen and (max-width: 768px) {
  .header {
    height: 200px;
    .w-header {
      padding: 0 54px;
      .nav-left {
        .logo {
          margin: 0;
          img {
            height: 140px;
          }
        }
      }
    }
  }
}
.en-container {
  .header {
    .nav-left {
      .nav-list {
        .nav-second {
          &.products {
            .nav-second-content {
              &.products {
                .nav-second-wrap:not(:last-child):after {
                  right: -230px;
                }
                .nav-second-wrap {
                  .nav-third {
                    .nav-third-item {
                      align-items: flex-start!important;
                    }
                    .nav-third-item:nth-child(1),
                    .nav-third-item:nth-child(2) {
                      min-height: 90px;
                    }
                    .nav-third-item:nth-child(3) {
                      min-height: 103px;
                    }
                  }
                }
                .nav-third {
                  .nav-product-col {
                    width: 270px;
                    .nav-third-item {
                      align-items: flex-start!important;
                    }
                    .nav-third-item:nth-child(1) {
                      min-height: 90px;
                    }
                    .nav-third-item:nth-child(3) {
                      min-height: 103px;
                    }
                  }
                }
              }
            }
          }
          &.scenes {
            .nav-second-wrap {
              .nav-third {
                .nav-third-col:nth-child(2)::after,
                .nav-third-col:nth-child(3)::after {
                  right: -220px;
                  z-index: 0;
                }
                .nav-third-col {
                  .nav-third-item {
                    width: 260px;
                    .item-name {
                      .text-wrap {
                        // width: 220px;
                        .label,
                        .desc {
                          width: 100%;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          &.industrys {
            left: 216px;
            .nav-second-list {
              width: 1300px;
              .nav-second-wrap {
                .nav-third {
                  .nav-third-outer:nth-child(1),
                  .nav-third-outer:nth-child(5),
                  .nav-third-outer:nth-child(9),
                  .nav-third-outer:nth-child(13) {
                    flex: 0 0 20%;
                    .nav-third-item {
                      width: 100%;
                    }
                  }
                  .nav-third-outer:nth-child(3),
                  .nav-third-outer:nth-child(7),
                  .nav-third-outer:nth-child(11),
                  .nav-third-outer:nth-child(15) {
                    flex: 0 0 28%;
                    .nav-third-item {
                      width: 98%;
                    }
                  }
                  .nav-third-outer:nth-child(4),
                  .nav-third-outer:nth-child(8),
                  .nav-third-outer:nth-child(12),
                  .nav-third-outer:nth-child(16) {
                    flex: 0 0 23%;
                    .nav-third-item {
                      width: 98%;
                    }
                  }
                  .nav-third-item {
                    width: 96%;
                  }
                }
              }
            }
          }
          &.about {
            left: 976px;
          }
        }
      }
    }
  }
}
</style>
